<style scoped>
    .chips-img-shadow>img{
        box-shadow: 0px 3px 2px 0px #000;
    }
    .swiper{
        --swiper-navigation-color: #fff;/* 单独设置按钮颜色 */
        --swiper-navigation-size: 1.8rem;/* 设置按钮大小 */
    }
    .text-red{
        color:#c90013;
    }
    .amount.active{
        animation: amount .5s ease infinite alternate;
    }
    .hover-bg-opacity-50:hover{
        --bs-bg-opacity: 0.5;
    }
    #fullPearl{
        transition: left .5s ease;
    }
    .big-scale-small{
        animation: big-scale-small .2s ease-in .2s;
    }
    @keyframes big-scale-small{
        0%{
            font-size: 4rem;
        }
        100%{
            font-size: 1.5rem;
        }
    }
    @keyframes amount {
        0% {
            box-shadow: rgb(249,252,0) 0 0 .2rem .2rem;
        }
        100% {
            box-shadow: rgba(249,252,255) 0 0 .2rem .2rem;
        }
    }
    .coruscate{
        animation: coruscate .5s ease infinite alternate;
    }
	@keyframes coruscate {
        0% {
            background: rgba(25,135,84,1);
        }
        100% {
            background: rgba(13,202,240);
        }
    }
    .scale-2{
        animation:scale2 .12s ease-out;
    }
    @keyframes scale2 {
        0% {
            transform: scale(1);
        }
        100% {
            transform: scale(1.5);
        }
    }
    .untransition{
        transition: none !important;
    }
    .hover-scale:hover{
        transform: scale(1.15);
        transition: transform .5s cubic-bezier(.25, 1.15, .35, 3.08);
    }
    .monk-active::before{
        content: "";
        width:3rem;
        height:3rem;
        position: absolute;
        top: 5%;
        left: 48%;
        transform: translateX(-50%);
        border-radius: 50%;
        box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        animation: monk-circle 1.5s linear infinite alternate;
    }
    .monk-active::after{
        content: "";
        display: block;
        background: repeating-conic-gradient(rgba(0,206,255,0) 0deg, rgb(255, 255, 255) 15deg, transparent 30deg);
        mask-image: radial-gradient(rgba(0,0,0,1), rgba(255,255,255,0) 72%);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        /* animation: rays-rotate 10s linear infinite,rays-scale 1s linear infinite alternate; */
        animation: rays-rotate 20s linear infinite,monk-rays-scale 1s linear infinite alternate;
    }
    @keyframes monk-rays-scale{
		0%{
			width: 50%;
			height: 50%;
		}
		100% {
			width: 90%;
			height: 90%;
        }
	}
    .animal-active{
        transition: transform 1s cubic-bezier(.25, 1.15, .35, 3.08);
        transform:none;
    }
    .weather-active::after{
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        background: url(@/assets/images/room/bac/border_style_2.png) no-repeat;
        background-size: 107rem 5.3rem;
        background-position: -0.4rem -1rem;
        z-index: 1;
        /* animation: border-style-2 2.5s steps(16) infinite; */
        animation: border-style-2 2s steps(20) infinite;
    }
    @keyframes border-style-2 {
        from{
            background-position:-0.4rem -1rem;
        }
        to{
            background-position:-107.25rem -1rem;
        }
    }
    @keyframes monk-circle {
        0% {
            box-shadow: 0 0 .6rem .1rem yellow,0 0 .4rem yellow inset;
        }
        100% {
            box-shadow: 0 0 .1rem .1rem yellow,0 0 .1rem yellow inset;
        }
    }
    .text-indent-2rem{
        text-indent: 2rem;
    }
    .get-card{
        left: 50%;
        top:50%;
        width: 5rem;
        transform:translate(-50%,-50%) rotate(0deg);
        animation: get-card-move 1s linear 1s,get-card-rotate 1s linear 1s;
    }
    .get-card.animal,.get-card.weather{
        box-shadow: 0 0 .8rem yellow;
    }
    .get-card.monk{
        width: 6rem;
    }
    @keyframes get-card-move {
        0%{
            width: 5rem;
            left: 50%;
            top:50%;
        }
        70%{
            width: 5rem;
        }
        100% {
            left: 100%;
            top: 0%;
            width: 0;
        } 
    }
    @keyframes get-card-rotate {
        100% {
            transform: translate(-50%,-50%) rotate(1440deg); 
        }
    }
    .btn-new-navy{
        background:linear-gradient(180deg,#F38C35 10%,#9D0000 90%); 
        border:1px solid #fff;
    }
    .btn-multiple{
        background:linear-gradient(180deg,#F96C18 30%,#FEEF67 90%); 
        border:1px solid #fff;
    }
    .pool{
        background:#B89227 !important;
        border:1px solid #fff !important;
    }
    .pool-title,.table-red-title{
        background-clip: text;
        -webkit-background-clip: text;
        color: transparent;
        -webkit-text-fill-color: transparent;
        /* 文字渐变效果 */
        background-image: linear-gradient(to bottom, #E9DB43 55%, #FFFFDE 45%);
    }
    .table-red-title{
        /* 文字渐变效果 */
        background-image: linear-gradient(to bottom, #d5c410 55%, #7f7f00 45%);
    }
    .table-red{
        background-color:#FAF7CE !important;
        border:1px solid #fff !important;
    }
    .tab-content{
        background-color: #FAF7C9;
    }
    .pool-text{
        background-color: #7E090B;
    }
    .pool-name{
        background-color: #DFCC84;
    }
    .pool-name-val{
        background-color: #fff;
        border:1px solid #7E090B;
    }
    .logo-bg{
        background: url(@/assets/images/room/g_logobj.png) no-repeat;
        background-size: 100% 100%;
    }
    .table-list-ul{
        background-color: #D79B4E;
    }
    .table-name{
        background:linear-gradient(180deg,#FEEB66 30%,#F83F08 80%); 
        border:1px solid #51230F;
    }
    .chips-bg{
        background-color: #C29421;
    }
    .btn-bg{
        background-color: #D79C49;
    }
    .feedback,.clearbg{
        background:linear-gradient(180deg,#0529AB 30%,#000239 50%,#0529AB 80%); 
        border:2px solid #6365A9;
    }
    .btnbg{
        background:linear-gradient(180deg,#FFFFF3 10%,#FCC64E 25%,#F95D0D 80%); 
        border:2px solid #540505;
        color: #220000;
    }
    .bet-border{
        border-bottom-left-radius: 15% 100%;
        border-bottom-right-radius: 15% 100%;
        overflow: hidden;
        border: 3px solid #fff;
    }
    .bet-submit{
        background:linear-gradient(180deg,#09351E 20%,#1A5E34 80%); 
    }
    .countdown{
        background:linear-gradient(90deg,#E4C895 30%,#BD8121 80%); 
        border:2px solid #86251E;
    }
    .countdown-time{
        background:linear-gradient(180deg,#0D0C0C 10%,#8E8E8E 80%); 
        border:2px solid #000000;
    }
    .multiplebg{
        background:linear-gradient(90deg,#2C2C2C 30%,#121212 50%,#2C2C2C 100%); 
    }
    .btn-mul-top{
        border:2px solid transparent;
        background: 
                linear-gradient(180deg,#595959 40%,#0E0E0E 100%) padding-box,
                linear-gradient(to bottom, #E0B642, #D4550C) border-box;
    }
    .btn-mul-bottom{
        border:2px solid #FFC841;
        background: linear-gradient(90deg,#7F0005 0%,#C00009 50%,#7F0005 100%);
    }
    .mulbg-footer{
        border-top:1px solid #9B6C2A;
        background: linear-gradient(180deg,#2F2F2F 0%,#5E5E5E 50%,#060606 70%,#3C3C3C 100%);
    }
    .footer-info{
        color: #CFCE29;
        background-color: #000000;
        border: 1px solid #686868;
    }
    .ffen{
        font-family: serif;
        font-weight: bold;
    }
    .cmdiy-con{
         background: url(@/assets/images/room/switchcmbj.png) no-repeat;
        background-size: 100% 100%;
    }
    .cmdiy-tit{
        background: linear-gradient(90deg,#500615 0%,#a5161b 50%,#4b0515 100%);
    }
    .cmdiy-btn{
        border: 1px solid #ff6600;
        background: linear-gradient(90deg,#760b05 0%,#d9330b 50%,#6c0705 100%);
        color: white;
    }
    @media (min-width:576px) {
        .tel-video-h{
            /* 26.917rem */
            height: 23.211rem;
        }
        .layer-absolute::after{
            border-radius: 1rem;
        }
        .weather-active::after{
            background-size: 148.25rem 8rem;
        }
        @keyframes border-style-2 {
            from{
                background-position:-0.4rem -1rem;
            }
            to{
                background-position:-148.45rem -1rem;
            }
        }
    }
    @media (min-width:768px) {
        .tel-video-h{
            height: 25.523rem;
        }
        .userinfo-diy{
            line-height: 1;
        }.userinfo-diy span{
            font-size: 0.6rem;
        }.btn-diy{
            padding: 0.2rem 0.6rem !important;
            height: max-content;;
            font-size: 0.8rem !important;
        }
    }
    @media (min-width: 992px){
        .tel-video-h{
            height: 27.072rem;
        }.userinfo-diy{
            line-height: 1.1;
        }.userinfo-diy span{
            font-size: 0.8rem;
        }.btn-diy{
            padding: 0.2rem 0.6rem !important;
            height: max-content;;
            font-size: 0.85rem !important;
        }
    }
    @media (min-width: 1200px){
        .tel-video-h{
            height: 27.194rem;
        }.userinfo-diy span{
            font-size: 1rem;
        }
    }
    @media (min-width: 1400px){
        .tel-video-h{
            height: 28.656rem;
        } 
        .userinfo-diy{
            line-height: 1.2;
        }.userinfo-diy span{
            font-size: 1.2rem;
        }.btn-diy{
            padding: 0.2rem 0.6rem !important;
            height: max-content;;
            font-size: 1rem !important;
        }
    }@media (min-width: 1600px){
        .btn-diy{
            padding: 0.5rem 0.7rem !important;
            height: max-content;;
            font-size: 1rem !important;
        }
    }@media (max-height: 750px){
        .h-sm-10rem{
			height: 11rem;
		}
        .userinfo-diy{
            line-height: 0.9;
        }.userinfo-diy span{
            font-size: 0.9rem;
        }
    }
</style>
<template>
    <div class="d-flex flex-column h-100">
        <!-- 横向导航 -->
        <navbar :class="[isMultiple?'d-none':'d-sm-none']" class="order-first d-flex flex-column" :has-chat-msg="hasChatMsg" :is-page-ready="isPageReady" :is-fullscreen="isFullscreen" ></navbar>
        <div class="d-flex h-100" v-if="isMultiple">
            <div v-for="(i,item) in getBetRoomList" :key="item" class="d-flex flex-grow-1 flex-column" :class="[item==1?'mx-1':'', (gameModel==GAME_MODEL.normal)?(isMultiple?'h-100':''):(isMultiple?'position-relative flex-sm-row':'')]" style="width: 33.333%;">
                
                <!-- 经典 -->
                <div :class="{'order-1':isMultiple}" class="d-flex flex-column flex-sm-row position-relative flex-grow-0">
                    <!-- 视频区 -->
                    <div class="d-flex flex-column flex-grow-1 position-relative">
                        <!-- 多台顶部 -->
                        <div class="d-flex justify-content-between multiplebg align-items-center">
                            <span class="text-light px-1 mx-1 small">{{i.boot}}-{{i.innings}}</span>
                            <div class="dropdown d-flex flex-grow-1 me-1 small">
                                <button type="button" class="dropdown-toggle btn-mul-top px-2 text-light rounded-3 w-100" data-bs-toggle="dropdown">
                                    {{i.room}} {{i.table}}
                                </button>
                                <ul class="dropdown-menu">
                                    <li class="dropdown-item" @click="changeBetRoomList(item.id,i.id)" v-for="(item,j) in roomList.filter(v=>v.id!=i.id)" :key="(item,j)">{{item.room}} - {{item.table}}</li>
                                </ul>
                            </div>
                            <span class="btn-mul-top rounded-3 text-light small px-2 me-1" @click="$root.setFullscreen">视频</span>
                            <span class="btn-mul-top rounded-3 text-light small px-2 me-1" @click="$root.setCurrModal($t('common.userRecords'))">记录</span>
                            <span class="btn-mul-top rounded-3 text-light small px-2 me-1" @click="$root.setCurrModal($t('common.limitRules'))">限额</span>
                            <span class="btn-mul-top rounded-3 text-light small px-2 me-1" >规则</span>
                        </div>
                        <!-- 视频 -->
                        <div class="d-flex h-0 position-relative index-1 overflow-hidden flex-grow-1 pt-52" >
                            <media-video :id="'video'+i.id" class="position-xs-absolute top-0 start-0 position-absolute" :class="{'scale-video':isScale}" :video-index="0" :video-list="videoList.find(v=>v.id==i.id)?videoList.find(v=>v.id==i.id).videoArr:[]" :countdown="i.countdown" :room-class="(!isMultiple)?['top-xs-0 top-sm-0 mt-2 mt-sm-5 ms-2']:['top-xs-0 top-sm-0 m-2']" :time-class="(!isMultiple)?['top-0 mt-2 mt-sm-5 ms-2']:['top-0 m-2 mt-sm-5']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="videoReady"></media-video>
                        </div>
                        <!-- 多台视频底部 -->
                        <div class="d-flex justify-content-center mulbg-bottom align-items-center btn-mul-bottom ">
                            <span class="rounded-3 text-light small">{{ i.countdown==0?"等待开局":"开局中" }}</span>
                        </div>
                    </div>
                </div>
                <!-- 选筹,下注区 -->
                <div class="d-flex flex-grow-1 flex-column position-relative" :class="{'order-2':isMultiple}">
                    <div class="d-flex flex-column justify-content-between" :class="{'order-2':isMultiple}">
                        <div :class="{'flex-sm-column-reverse':isMultiple}" class="d-flex flex-column px-1 px-sm-0">
                            
                            <!-- 选筹区 -->
                            <div class="d-flex align-items-center text-black order-2 order-sm-1 flex-grow-1 col position-relative" :class="{'multiplebg mb-0':isMultiple}">
                                <div class="d-flex rounded-3 justify-content-between justify-content-sm-around align-items-center flex-grow-1">
                                    <div @click.stop="showMoreAmount(i.id)" class="text-light me-2 ms-2">
                                        <img class="w-3rem rounded-circle chips-shadow" :src="require('@/assets/images/room/bet/sbetbtn.png')" alt="">
                                    </div>
                                    <div v-for="(item,j) in currAmountList.find(v=>v.id==i.id)?currAmountList.find(v=>v.id==i.id).amount:defaultAmountList" :key="j" class="d-flex justify-content-around align-items-center col">
                                        <div class="position-relative chips rounded-circle my-1" :class="{active:betRoomInfoList.find(v=>v.id==i.id)&&betRoomInfoList.find(v=>v.id==i.id).amount==item}" @click="setRoomAmount(i.id,item)" role="button">
                                            <img class="w-3rem rounded-circle chips-shadow" :src="require('@/assets/images/room/bet/chips_'+item+'.png')" alt="">
                                        </div>
                                    </div>
                                    <div class="position-relative chips rounded-circle my-1">
                                        <img class="w-3rem rounded-circle chips-shadow" src="@/assets/images/room/bet/chips_Infinity.png" alt="">
                                    </div>
                                </div>
                                <div v-if="showMoreAmountRoomIdArr.find(v=>v.id==i.id)" class="position-absolute start-50 top-50 translate-middle-x rounded-3 d-flex flex-column index-2">
                                    <span class="text-warning fs-5 text-center border border-warning lh-1 cmdiy-tit">自定筹码</span>
                                    <div class="d-flex flex-column cmdiy-con">
                                        <div class="d-flex flex-column px-3">
                                            <div class="d-flex justify-content-between my-2">
                                                <div v-for="j in AMOUTN_ARR.slice(0,5)" :key="j" @click="setRoomAmountList(i.id,j)" class="position-relative ms-3 me-3 ms-sm-0 me-sm-1 chips rounded-circle" role="button">
                                                    <img class="w-3rem rounded-circle chips-shadow" :class="{'border border-3 border-warning':showMoreAmountRoomIdArr.find(v=>v.id==i.id).amountArr.find(v=>v==j)}" :src="require('@/assets/images/room/bet/chips_'+j+'.png')" alt="">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between my-2">
                                                <div v-for="j in AMOUTN_ARR.slice(5)" :key="j" @click="setRoomAmountList(i.id,j)" class="position-relative ms-3 me-3 ms-sm-0 me-sm-1 chips rounded-circle" role="button">
                                                    <img class="w-3rem rounded-circle chips-shadow" :class="{'border border-3 border-warning':showMoreAmountRoomIdArr.find(v=>v.id==i.id).amountArr.find(v=>v==j)}" :src="require('@/assets/images/room/bet/chips_'+j+'.png')" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-evenly mb-1">
                                            <button type="button" class="btn cmdiy-btn text-light px-3" @click="saveAmount(i.id)">保存</button>
                                            <button type="button" class="btn cmdiy-btn text-light px-3" @click="this.showMoreAmountRoomIdArr.splice(this.showMoreAmountRoomIdArr.findIndex(v=>v.id==i.id),1)">取消</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-grow-1 position-relative" :class="{'order-1':isMultiple}">
                        <!-- 提交区 -->
                        <div class="position-xs-relative start-0 end-0 bottom-0 top-0" :class="{'flex-grow-1 d-flex order-1':isMultiple}">
                            <!-- 背景色(因内联样式无法使用媒体查询所以这么写) -->
                            <div class="position-absolute w-100 h-100 d-sm-none" :style="{'background':i.bgcolor}"></div>
                            <!-- 操作区 -->
                            <div v-if="gameModel==GAME_MODEL.normal" class="position-xs-relative bottom-0 index-1" :class="{'perspective-600':!isMultiple,'flex-grow-1 d-flex':isMultiple,'scale-submit':isScale==true}">
                                <div class="pb-1 pb-sm-0" :class="{'flex-grow-1 d-flex mb-sm-0 mb-md-0':isMultiple,'mb-sm-2 me-1 mt-sm-1 mt-md-2':!isMultiple}">
                                    <div class="d-flex flex-column" :class="{'flex-grow-1':isMultiple,'flex-sm-row align-items-sm-end justify-content-center':!isMultiple}">
                                        <div class="d-flex flex-column flex-grow-1" :class="{'flex-sm-row':!isMultiple}">
                                            <!-- 切换区 -->
                                            <div class="d-flex flex-column flex-grow-1 flex-column-reverse flex-sm-column-reverse" :class="{'flex-sm-column-reverse':isMultiple}">
                                                
                                                <!-- 提交区 -->
                                                <div :class="{'flex-grow-1 align-items-sm-stretch':isMultiple,'bet-border':!isMultiple,'mb-sm-0':isMultiple}" class=" d-flex flex-wrap justify-content-center align-items-sm-end align-items-lg-stretch position-relative order-1 order-sm-2 text-center mb-2">
                                                    
                                                    <!-- xd -->
                                                    <div v-if="roomList.find(v=>v.id==i.id).game==GAME_ID.bac" class="bet-submit d-flex col-4 justify-content-center border-solid border-xs border-end-xs-0 border-bottom-xs-0 border-end-0 border-bottom-sm-0 border-light position-relative flex-grow-1 overflow-hidden" :class="{'flex-column border border-1 border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==i.id)&& coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('xd')!=-1,'layer-absolute':odds.xd==0&&!isMultiple}" @click="addAmount('xd',$event,i.id)">
                                                        <div v-show="pool.xd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 71, 133,.5)',height: pool.xd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%'}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{pool.xd}}</span>
                                                        </div>
                                                        <div class="small text-white-50 text-nowrap align-content-center" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div :class="{'fs-4':!isMultiple}" style="color:#FFFE35">P.PAIR</div>
                                                            <div :class="{'d-none':isMultiple}">1:{{odds.xd}}</div>
                                                        </div>
                                                        <span class="fs-2 fw-bold d-flex flex-column justify-content-center text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-2 mx-md-2 py-sm-2']" :style="{'color':COLOR.blueDark}">{{$t("common.xd")}}</span>
                                                        <div v-for="j,index in chipsConvert(betRoomInfoList.find(v=>v.id==i.id)?(betRoomInfoList.find(v=>v.id==i.id).submited.xd+betRoomInfoList.find(v=>v.id==i.id).submiting.xd):0)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.xd}">
                                                                <small class="text-shadow-white">{{betRoomInfoList.find(v=>v.id==i.id)&&(betRoomInfoList.find(v=>v.id==i.id).submited.xd+betRoomInfoList.find(v=>v.id==i.id).submiting.xd>0?betRoomInfoList.find(v=>v.id==i.id).submited.xd+betRoomInfoList.find(v=>v.id==i.id).submiting.xd:'')}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- h -->
                                                    <div class="bet-submit d-flex col-4 flex-column justify-content-center border-solid border-xs border-end-xs-0 border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-top-sm-0':!isMultiple,'flex-column border bg-success':isMultiple,'border-bottom-0':i.game==GAME_ID.bac,'coruscate':coruscateArr.find(v=>v.id==i.id)&&coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('h')!=-1,'order-sm-2':i.game==GAME_ID.bac&&!isMultiple,'order-2':i.game!=GAME_ID.bac,'border-bottom-xs-0':i.game==GAME_ID.bac,'layer-absolute':odds.h==0&&!isMultiple}" @click="addAmount('h',$event,i.id)">
                                                        <div class="d-flex justify-content-center" :class="{'flex-column':isMultiple}">
                                                            <div v-show="pool.h>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 170, 0,.5)',height: pool.h/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.green}">
                                                                <span class="position-absolute top-0 translate-end-y index-1">{{ pool.h }}</span>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[i.game==GAME_ID.lh?'fs-xs-2 fs-1 lh-2-4 my-2 my-sm-0 lh-4 lh-sm-base border-sm-0':'',isMultiple?(i.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(i.game==GAME_ID.lh?'mx-sm-2 mx-md-2 px-sm-2 py-sm-2':'fs-1 mx-sm-2 mx-lg-2  py-sm-2 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                                            <div class="small text-white-50 text-nowrap align-content-center">
                                                                <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">TIE</div>
                                                                <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'':'')]">1:{{odds.h}}</div>
                                                            </div>
                                                            <div v-for="j,index in chipsConvert(betRoomInfoList.find(v=>v.id==i.id)?(betRoomInfoList.find(v=>v.id==i.id).submited.h+betRoomInfoList.find(v=>v.id==i.id).submiting.h):0)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                                <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.h}">
                                                                    <small class="d-block text-shadow-white">{{betRoomInfoList.find(v=>v.id==i.id)&&(betRoomInfoList.find(v=>v.id==i.id).submited.h+betRoomInfoList.find(v=>v.id==i.id).submiting.h>0?betRoomInfoList.find(v=>v.id==i.id).submited.h+betRoomInfoList.find(v=>v.id==i.id).submiting.h:'')}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <!--- 倒计时 -->
                                                        <div class="countdown justify-content-between align-items-center m-2" :class="[i.game==GAME_ID.lh&&!isMultiple?'d-flex border-solid border-1 border-light border-top-1':'d-none']">
                                                            <div class="small text-white-50 text-nowrap align-content-center ps-4" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="text-black fw-bold" :class="{'fs-6':!isMultiple}" >剩余押注时间</div>
                                                                <div class="text-black fw-bold">TIME</div>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-light pe-2 countdown-time m-1 px-sm-4 rounded-3" :class="[i.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-1 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(i.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(i.game==GAME_ID.lh?'mx-sm-2 px-sm-3 px-md-4 m-1':'fs-2 mx-sm-2 px-sm-2')]" :style="'color:'+COLOR.blue">{{i.countdown}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- zd -->
                                                    <div v-if="roomList.find(v=>v.id==i.id).game==GAME_ID.bac" class="bet-submit d-flex col-4 justify-content-center border-solid border-xs border-bottom-xs-0 border-bottom-sm-0 border-start-0 border-light position-relative flex-grow-1" :class="{'col-sm-4 order-sm-2 border-sm-2 border-top-sm-0 border-end-0':!isMultiple,'flex-column border border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==i.id)&&coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('zd')!=-1,'layer-absolute':odds.zd==0&&!isMultiple}" @click="addAmount('zd',$event,i.id)">
                                                        <div v-show="pool.zd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 0, 0,.5)',height: pool.zd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.redDark}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.zd }}</span>
                                                        </div>
                                                        <span class="fs-2 fw-bold d-flex flex-column justify-content-center text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-2 py-sm-2']" :style="'color:'+COLOR.redDark">{{$t("common.zd")}}</span>
                                                        <div class="small text-white-50 text-nowrap align-content-center" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div :class="{'fs-4':!isMultiple}" style="color:#FFFE35">B.PAIR</div>
                                                            <div :class="{'d-none':isMultiple}">1:{{odds.zd}}</div>
                                                        </div>
                                                        <div v-for="j,index in chipsConvert(betRoomInfoList.find(v=>v.id==i.id)?(betRoomInfoList.find(v=>v.id==i.id).submited.zd+betRoomInfoList.find(v=>v.id==i.id).submiting.zd):0)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.zd}">
                                                                <small class="d-block text-shadow-white">{{betRoomInfoList.find(v=>v.id==i.id)&&(betRoomInfoList.find(v=>v.id==i.id).submited.zd+betRoomInfoList.find(v=>v.id==i.id).submiting.zd>0?betRoomInfoList.find(v=>v.id==i.id).submited.zd+betRoomInfoList.find(v=>v.id==i.id).submiting.zd:'')}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- x -->
                                                    <div class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'flex-column border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==i.id)&&coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('x')!=-1,'order-sm-2 col-4 border-end-xs-0':i.game==GAME_ID.bac,'border-end-0':i.game==GAME_ID.bac,'col-4 order-3':i.game!=GAME_ID.bac,'layer-absolute':odds.x==0&&!isMultiple}" @click="addAmount('x',$event,i.id)">
                                                        <div v-show="pool.x>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 105, 197,.5)',height: (pool.x/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.blue}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.x }}</span>
                                                        </div>
                                                        <div class="small text-white-50 text-nowrap align-content-center">
                                                            <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">{{i.game==GAME_ID.lh?'TIGER':'PLAYER'}}</div>
                                                            <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.x:1}}</div>
                                                        </div>
                                                        <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[i.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-1 lh-4 lh-sm-base border-sm-0':'',isMultiple?(i.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(i.game==GAME_ID.lh?'mx-sm-2 px-sm-2 py-sm-5':'fs-1 mx-sm-2 py-sm-2 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",i.game,1)}}</span>
                                                        <div v-for="j,index in chipsConvert(betRoomInfoList.find(v=>v.id==i.id)?(betRoomInfoList.find(v=>v.id==i.id).submited.x+betRoomInfoList.find(v=>v.id==i.id).submiting.x):0)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.x}">
                                                                <small class="d-block text-shadow-white">{{betRoomInfoList.find(v=>v.id==i.id)&&(betRoomInfoList.find(v=>v.id==i.id).submited.x+betRoomInfoList.find(v=>v.id==i.id).submiting.x>0?betRoomInfoList.find(v=>v.id==i.id).submited.x+betRoomInfoList.find(v=>v.id==i.id).submiting.x:'')}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- time -->
                                                    <div v-if="i.game==GAME_ID.bac&&!isMultiple" class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==i.id)&&coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('x')!=-1,'order-sm-2 col-6 border-end-xs-0':i.game==GAME_ID.bac,'border-end-0':i.game==GAME_ID.bac&&isMultiple,'col-4 order-3':i.game!=GAME_ID.bac,'me-sm-2':i.game!=GAME_ID.bac&&!isMultiple,'layer-absolute':odds.x==0}" @click="addAmount('x',$event)">
                                                        <div class="countdown d-flex justify-content-between m-2 align-items-center">
                                                            <div class="small text-white-50 text-nowrap align-content-center ps-4" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="text-black fw-bold" :class="{'fs-6':!isMultiple}" >剩余押注时间</div>
                                                                <div class="text-black fw-bold">TIME</div>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-light pe-2 countdown-time m-1 px-sm-4 rounded-3" :class="[i.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(i.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(i.game==GAME_ID.lh?'mx-sm-2 px-sm-3 px-md-5':'fs-2 mx-sm-2 px-sm-2')]" :style="'color:'+COLOR.blue">{{i.countdown}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- z -->
                                                    <div class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'flex-column border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==i.id)&&coruscateArr.find(v=>v.id==i.id).coruscate.indexOf('z')!=-1,'order-sm-4 col-4':i.game==GAME_ID.bac,'col-4 order-1 border-end-xs-0':i.game!=GAME_ID.bac,'border-start-0':i.game==GAME_ID.bac&&!isMultiple,'border-end-0':i.game!=GAME_ID.bac&&isMultiple,'layer-absolute':odds.z==0&&!isMultiple}" @click="addAmount('z',$event,i.id)">
                                                        <div v-show="pool.z>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 40, 40,.5)',height: (pool.z/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.red}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.z }}</span>
                                                        </div>
                                                        <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[i.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-3 fs-1 lh-4 lh-sm-base border-sm-0':'',isMultiple?(i.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-3 mb-4':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(i.game==GAME_ID.lh?'mx-sm-2 px-sm-2':'fs-1 mx-sm-2 py-sm-2 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",i.game,0)}}</span>
                                                        <div class="small text-white-50 text-nowrap align-content-center">
                                                            <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'lh-xs-3 lh-sm-3 lh-xl-4':'lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">{{i.game==GAME_ID.lh?'DRAGON':'BANKER'}}</div>
                                                            <div :class="[i.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(i.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(i.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.z:1+(i.game==GAME_ID.bac?'('+$t("room.rebateTxt")+')':'')}}</div>
                                                        </div>
                                                        <div v-for="j,index in chipsConvert(betRoomInfoList.find(v=>v.id==i.id)?(betRoomInfoList.find(v=>v.id==i.id).submited.z+betRoomInfoList.find(v=>v.id==i.id).submiting.z):0)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.z}">
                                                                <small class="d-block text-shadow-white">{{betRoomInfoList.find(v=>v.id==i.id)&&(betRoomInfoList.find(v=>v.id==i.id).submited.z+betRoomInfoList.find(v=>v.id==i.id).submiting.z>0?betRoomInfoList.find(v=>v.id==i.id).submited.z+betRoomInfoList.find(v=>v.id==i.id).submiting.z:'')}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- 更多筹区 -->
                                                    <change-amount :class="{'rounded-sm-10':!isMultiple}" :is-show="isShowMoreAmount"></change-amount>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 按钮区 -->
                                        <div class="d-flex justify-content-evenly text-nowrap order-3 mb-1 mb-sm-0 px-1" :class="{'ps-sm-0 pe-sm-2 pt-1 multiplebg':isMultiple}">
                                            <span class="fw-bold fs-2 text-center text-red">{{roomList.find(v=>v.id==i.id).countdown}}</span>
                                            <div type="button" class="text-light" @click="submitEvent('clear',i.id)">
                                                <img class="w-3rem" src="@/assets/images/room/many_clearbtn01.png" alt="">
                                            </div>
                                            <div type="button" class="text-light" @click="submitEvent('again',i.id)">
                                                <img class="w-3rem" src="@/assets/images/room/many_reap01.png" alt="">
                                            </div>
                                            <div type="button" class="text-light" @click="submitEvent('confirm',i.id)">
                                                <img class="w-3rem" src="@/assets/images/room/many_sure01.png" alt="">
                                            </div>
                                            <div v-if="i.iscommission==IS_REBATE.true" @click="setRebate($event)" class="w-4rem d-flex align-items-center index-1">
                                                <img v-if="currRebate!=REBATE_TYPE.noRebate" class="w-100" src="@/assets/images/room/mStyle01.png" alt="">
                                                <img v-else class="w-100" src="@/assets/images/room/mStyle02.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>        
                <!-- 多台路单区 -->
                <div v-if="isMultiple" class="d-flex position-relative order-3 overflow-hidden bg-black">
                    <div class="d-flex flex-column justify-content-evenly align-item-center">
                        <div class="px-2 mx-2 small text-danger">{{$root.getTextByGame("common.",i.game,0)}}</div>
                        <div class="px-2 mx-2 small text-center text-light border border-1 border--solid border-light rounded-3">{{pearlCountList[i.id]?pearlCountList[i.id].z:0}}</div>
                        <div class="px-2 mx-2 small text-primary">{{$root.getTextByGame("common.",i.game,1)}}</div>
                        <div class="px-2 mx-2 small text-center text-light border border-1 border--solid border-light rounded-3">{{pearlCountList[i.id]?pearlCountList[i.id].x:0}}</div>
                        <div class="px-2 mx-2 small text-success">{{$t("common.h")}}</div>
                        <div class="px-2 mx-2 small text-center text-light border border-1 border--solid border-light rounded-3">{{pearlCountList[i.id]?pearlCountList[i.id].h:0}}</div>
                    </div>
                    <div :class="{'flex-sm-nowrap':pearlModel==1,'flex-column':pearlModel==2}" class="flex-grow-1 d-flex flex-wrap w-0">
                        <div :class="{'col-6 h-xs-50 h-sm-10rem':pearlModel==1,'h-xs-33 h-sm-10rem':pearlModel==2}" class="position-relative">
                            <canvas :id="'textBigPearl'+i.id" class="bg-light d-block mx-auto min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0"></canvas>
                            <div class="bg-dark bg-opacity-25 position-absolute" :style="pearlLayerStyle"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>




        <div v-else class="d-flex flex-grow-1" :class="{'flex-column':!isMultiple}">
            <div v-for="i in isMultiple?getBetRoomList.length:1" :key="i" class="d-flex flex-grow-1  flex-column" :class="[i==2?'mx-1':'', (gameModel==GAME_MODEL.normal)?(isMultiple?'h-100':'position-xs-relative start-0 end-0 top-0 h-0'):(isMultiple?'position-relative flex-sm-row':'position-relative')]">
                
                <!-- 经典 -->
                <div :class="{'order-1':isMultiple,'flex-sm-grow-0 h-50':!isMultiple}" class="d-flex flex-column flex-sm-row position-relative flex-grow-0">
                    <!--小视频（新修改）-->
                    <div v-if="!isMultiple" class="d-flex flex-column justify-content-between w-33 h-100">
                        <div class="d-flex h-0 position-relative index-1 overflow-hidden flex-grow-1">
                            <!-- <media-video id="video3" class="position-absolute top-0 bottom-0" :class="{'scale-video':isScale}" :video-index="1" :video-list="(videoList.find(v=>v.id==roomInfo.id)&&videoList.find(v=>v.id==roomInfo.id).videoArr.every(v=>v.indexOf('guanggao')==-1))?videoList.find(v=>v.id==roomInfo.id).videoArr:[]" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['top-xs-0 top-sm-0 mt-2 mt-sm-5 ms-2']:['top-xs-0 top-sm-0 m-2']" :time-class="(!isMultiple)?['top-0 mt-2 mt-sm-5 ms-2']:['top-0 m-2 mt-sm-5']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="videoReady"></media-video> -->
                            <media-video id="video3" class="position-absolute top-0 bottom-0" :class="{'scale-video':isScale}" :video-index="1" :video-list="(videoList.find(v=>v.id==roomInfo.id)&&videoList.find(v=>v.id==roomInfo.id).videoArr[1]&&videoList.find(v=>v.id==roomInfo.id).videoArr[1].indexOf('guanggao')==-1)?videoList.find(v=>v.id==roomInfo.id).videoArr:[]" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['top-xs-0 top-sm-0 mt-2 mt-sm-5 ms-2']:['top-xs-0 top-sm-0 m-2']" :time-class="(!isMultiple)?['top-0 mt-2 mt-sm-5 ms-2']:['top-0 m-2 mt-sm-5']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="videoReady"></media-video>
                        </div>
                        <div class="rounded-3 d-flex justify-content-between mx-2 px-2 px-sm-1 mx-sm-1 pt-2 h-30 userinfo-diy">
                            <div class="d-flex flex-column">
                                <div class="d-flex align-items-center px-1 rounded-pill text-light">
                                    <span class="text-nowrap" style="color:#EADE42">游戏账号</span>
                                    <span class="ps-3 text-nowrap">{{userInfo.id}}</span>
                                </div>
                                <div v-if="!($route.name=='share'||gameModel==GAME_MODEL.tel)" class="d-flex align-items-center px-1 rounded-pill text-light">
                                    <span class="align-middle text-nowrap">目前金额</span>
                                    <span class="align-middle ps-3 text-nowrap">{{userInfo.realCoin}}</span>
                                </div>
                                <div class="d-flex align-items-center px-1 rounded-pill text-light">
                                    <span class="text-nowrap">总下注金</span>
                                    <span class="ps-3 text-nowrap">{{getAmountCount("submited")}}</span>
                                </div>
    
                                <div class="d-flex align-items-center px-1 rounded-pill text-light">
                                    <span class="text-nowrap">赢得奖金</span>
                                    <span class="ps-3 text-nowrap">0</span>
                                </div>
                                <div class="d-flex align-items-center px-1 rounded-pill text-light">
                                    <span class="text-nowrap">状态&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                                    <span class="ps-4 text-nowrap">{{ roomInfo.countdown>0?'开始投注':'等待开局' }}</span>
                                </div>
                            </div>
                            <div class="d-flex  flex-column justify-content-between">
                                <div class="d-flex justify-content-between">
                                    <span class="btn btn-diy btn-new-navy rounded-5 text-light fw-bold rounded-5 fs-6 fs-sm-6 px-xxl-3 px-xl-2 px-sm-1 text-nowrap" @click="$root.setFullscreen">
                                        {{isFullscreen?$t("login.unFullscreen"):$t("login.fullscreen")}}
                                    </span>
                                    <span class="btn btn-diy btn-new-navy rounded-5 text-light fw-bold rounded-5 fs-6 px-lg-3 px-md-1 ms-3 ms-md-1 text-nowrap" @click="$root.goPage('home')">
                                        游戏{{$t("nav.home")}}
                                    </span>
                                </div>
                                <div class="d-flex justify-content-between ">
                                    <span class="btn btn-diy btn-new-navy rounded-5 text-light fw-bold rounded-5 fs-6 px-lg-3 px-md-1 text-nowrap" @click="$root.setFullscreen">
                                        全景1
                                    </span>
                                    <span class="btn btn-diy btn-new-navy rounded-5 text-light fw-bold rounded-5 fs-6 px-lg-3 px-md-1 ms-3 ms-md-1 text-nowrap" @click="$root.goPage('home')">
                                        全景2
                                    </span>
                                </div>
                                <div class="d-flex justify-content-between align-items-center">
                                    <span class="btn btn-diy btn-multiple rounded-5 text-light fw-bold rounded-5 fs-6 px-lg-3 px-md-1 text-nowrap" @click="submitEvent('multiple')">
                                        多臺下註
                                    </span>
                                    <span class="btn btn-diy fs-6 px-lg-3 px-md-1" type="button" @click="showFullScreen">
                                        <img class="img-fluid start-0" src="@/assets/images/room/music01.png">
                                    </span>
                                </div>
                            </div>

                        </div>     
                    </div>
                    <!-- 中间logo/彩池部分 -->
                    <div v-if="!isMultiple" class="d-flex flex-column mx-xxl-3 mx-sm-1" style="width: 18%;">
                        <div class="w-100 h-50 logo-bg img-fluid d-flex align-items-center">
                            <img class="d-none w-9rem d-sm-block mx-auto img-fluid pe-3 pb-3" src="logo.png" alt="">
                        </div>
                        <div class="d-flex flex-column flex-grow-1 p-sm-0 pt-sm-1">
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column w-50 text-center me-1 pool rounded-3">
                                    <span class="active pool-title p-1 fw-bold fs-5 text-nowrap" >即时彩池</span>
                                </div>
                                <div class="d-flex flex-column w-50 text-center table-red rounded-3">
                                    <span class="table-red-title p-1 fw-bold fs-5 text-nowrap" >台红</span>
                                </div>
                            </div>
                            <div class="tab-content d-flex flex-column mt-1 rounded-3">
                                <div class="tab-pane d-flex  flex-column active">
                                    <!-- z -->
                                    <div class="pool-text d-flex justify-content-between align-items-center m-1 rounded-5">
                                        <div class="w-50 pool-name rounded-5">
                                            <span class="pool-name-val rounded-5 px-3 fw-bold" :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                                            <span v-if="roomInfo.countdown" class="text-primary">{{ pool.z }}</span>
                                        </div>
                                        <span class="text-light w-50 ps-2">{{limitred.z}}</span>
                                    </div>
                                    <!-- x -->
                                    <div class="pool-text d-flex justify-content-between align-items-center mb-1 mx-1 rounded-5">
                                        <div class="w-50 pool-name rounded-5">
                                            <span class="pool-name-val rounded-5 px-3 fw-bold" :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                                            <span v-if="roomInfo.countdown" class="text-primary">{{ pool.x }}</span>
                                        </div>
                                        <span class="text-light w-50 ps-2">{{limitred.x}}</span>
                                    </div>
                                    <!-- h -->
                                    <div class="pool-text d-flex justify-content-between align-items-center mb-1 mx-1 rounded-5">
                                        <div class="w-50 pool-name rounded-5">
                                            <span class="pool-name-val rounded-5 px-3 fw-bold" :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                            <span v-if="roomInfo.countdown" class="text-primary">{{ pool.h }}</span>
                                        </div>
                                        <span class="text-light w-50 ps-2">{{limitred.h}}</span>
                                    </div>
                                    <!-- zd -->
                                    <div v-if="roomInfo.game==GAME_ID.bac" class="pool-text d-flex justify-content-between align-items-center mb-1 mx-1 rounded-5">
                                        <div class="w-50 pool-name rounded-5">
                                            <span class="pool-name-val rounded-5 px-2 fw-bold" :style="'color:'+COLOR.redDark">{{$t("common.zd")}}</span>
                                            <span v-if="roomInfo.countdown" class="text-primary">{{ pool.zd }}</span>
                                        </div>
                                        <span class="text-light w-50 ps-2">{{limitred.zd}}</span>
                                    </div>
                                    <!-- xd -->
                                    <div v-if="roomInfo.game==GAME_ID.bac" class="pool-text d-flex justify-content-between align-items-center mb-1 mx-1 rounded-5">
                                        <div class="w-50 pool-name rounded-5">
                                            <span class="pool-name-val rounded-5 px-2 fw-bold" :style="'color:'+COLOR.blueDark">{{$t("common.xd")}}</span>
                                            <span v-if="roomInfo.countdown" class="text-primary">{{ pool.xd }}</span>
                                        </div>
                                        <span class="text-light w-50 ps-2">{{limitred.xd}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 视频区 -->
                    <div class="d-flex flex-column flex-grow-1 position-relative">
                        <!-- 公告 -->
                        <notice></notice>
                        <!-- 视频 -->
                        <div class="d-flex h-0 position-relative index-1 overflow-hidden flex-grow-1" :class="{'flex-grow-1 pt-sm-0 pt-60':!isMultiple,'pt-52':isMultiple}">
                            <!-- <media-video v-if="isMultiple" id="video1" class="position-xs-absolute top-0 start-0" :class="{'position-absolute':isMultiple,'position-sm-relative top-0 start-0':!isMultiple,'scale-video':isScale}" :video-index="0" :video-list="videoList" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['top-xs-0 top-sm-0 mt-2 mt-sm-5 ms-2']:['top-xs-0 top-sm-0 m-2']" :time-class="(!isMultiple)?['top-0 mt-2 mt-sm-5 ms-2']:['top-0 m-2 mt-sm-5']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="videoReady"></media-video> -->
                            <media-video class="d-sm-block" id="video2" :video-index="0" :class="{'scale-video':isScale}" :video-list="videoList.find(v=>v.id==roomInfo.id)?videoList.find(v=>v.id==roomInfo.id).videoArr:[]" :countdown="roomInfo.countdown" :room-class="(!isMultiple)?['d-none']:['m-2']" :time-class="(!isMultiple)?['d-none']:['top-0 m-2']" :img-class="['position-absolute translate-middle top-50 start-50 w-100 h-sm-100']" @video-ready="v=>readyVideoIdArr.push(v)"></media-video>
                        </div>
                        <!-- 印记 -->
                        <!-- <div class="position-absolute top-0 end-0 index-1 mt-2 mt-sm-5 me-2  w-100 h-100 index-0">
                            <div class="position-absolute w-100 h-100 start-0 top-0 index-_1">
                                <div :class="[currRuleType==MARK_TYPE.animal?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-1 p-sm-2 position-absolute align-items-center" style="width:6rem;">
                                    <div :class="[(userInfo.markType!=MARK_TYPE.animal||i>(userInfo.mark||0))?'':'animal-active']" class="rotate-y-180 transform-3d position-relative w-100 h-xs-0 flex-grow-1">
                                        <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 fs-1 rotate-y-180 fw-bold d-flex justify-content-center align-items-center" :style="{background: 'url('+require('@/assets/images/room/bac/bg_style_1.jpg')+') no-repeat top left/100% 100%'}"></div>
                                        <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1 p-1 backface-hidden" :src="require('@/assets/images/room/bac/12animal/'+1+'.png')" alt="">
                                    </div>
                                </div>
                            </div>
                            <img @click="isShowMark=true" class="w-4rem hover-scale  position-relative index-1" src="@/assets/images/room/bac/mark.png" alt="">
                            <div v-show="isShowMark" class="position-xs-fixed position-sm-absolute bg-dark border border-3 border-secondary start-xs-50 translate-middle-xs end-100 top-xs-50 top-sm-0 rounded-5 me-sm-3 mt-sm-2 w-xs-22rem w-50rem h-30rem">
                                <div class="d-none d-sm-block position-absolute end-0 w-1rem h-2rem mt-1 start-100" style="background-repeat:no-repeat;background-position:left 1px,left bottom,1px 1px,1px bottom;background-image: linear-gradient(45deg,#212529 .55rem,transparent .55rem),linear-gradient(135deg,#212529 .55rem,transparent .55rem),linear-gradient(45deg,#6c757d 50%,transparent 50%),linear-gradient(135deg,#6c757d 50%,transparent 50%);background-size:100% 50%;"></div>
                                规则
                                <div v-if="isShowRule" class="d-flex flex-column flex-grow-1 mx-2 mx-sm-3 h-100">
                                    <div class="text-center position-relative text-light fw-bold py-2 border-bottom border-secondary">
                                        <div class="position-absolute top-50 start-0 translate-middle-y" @click="isShowRule=false">
                                            <i class="bi bi-arrow-left-circle me-1"></i>返回
                                        </div>
                                        <div class="position-absolute top-50 end-0 translate-middle-y" @click="isShowRule=false">
                                            <i class="bi bi-x-octagon fs-5" @click="isShowMark=false"></i>
                                        </div>
                                        <span class="fs-4">连中印记玩法规则</span>
                                    </div>
                                    <div class="flex-grow-1 text-light py-1 overflow-y-scroll">
                                        <div class="fw-bold">为使玩家收益更大化，现增加连中印记玩法，玩法规则如下：</div>
                                        <div class="d-flex flex-column my-1">
                                            <span class="text-info fw-bold"><i class="bi bi-dice-1 me-1"></i>活动概览：</span>
                                            <span class="text-indent-2rem">玩家每赢得一局游戏(盈利额大于投入额)，自动点亮一枚印记，若输掉一局游戏(盈利额小于投入额)，将失去所有印记。集齐所有印记将额外获得点亮印记时产生的盈利额的一定比例作为返利。</span>
                                        </div>
                                        <div class="d-flex flex-column my-1">
                                            <span class="text-info fw-bold"><i class="bi bi-dice-2 me-1"></i>难度说明：</span>
                                            <span class="text-indent-2rem">活动每次只能激活一种难度，活动共设3档难度，分别为十二生肖、十八罗汉、二十四节气，对应12、18、24枚印记，印记越多难度越大，返利比例越高，系统默认为用户激活第一档难度(十二生肖)。</span>
                                        </div>
                                        <div class="d-flex flex-column my-1">
                                            <span class="text-info fw-bold"><i class="bi bi-dice-3 me-1"></i>变更难度：</span>
                                            <span class="text-indent-2rem">当前未点亮印记时，可任意激活心仪难度。若当前有被点亮的印记，降低难度时需要重置进度，您将丢失所有已点亮印记。升级难度则无需重置进度，且已点亮印记将被继承到更高级别难度。</span>
                                        </div>
                                        <div class="d-flex flex-column my-1">
                                            <span class="text-info fw-bold"><i class="bi bi-dice-4 me-1"></i>结算说明：</span>
                                            <span class="text-indent-2rem">点亮选中难度的所有印记时，系统将自动结算返利并返还至玩家账户，同时活动进度重置，玩家可再次参与，活动次数不限。</span>
                                        </div>
                                        <div class="d-flex flex-column my-1">
                                            <span class="text-info fw-bold"><i class="bi bi-dice-5 me-1"></i>返利比例：</span>
                                            <span class="text-indent-2rem">十二生肖({{markOdds[0]}}%)、十八罗汉({{markOdds[1]}}%)、二十四节气({{markOdds[2]}}%)</span>
                                        </div>
                                    </div>
                                </div>
                                内容
                                <div v-else class="d-flex w-100 h-100">
                                    <div class="d-flex text-light text-vertical text-center">
                                        <div @click="currRuleType=MARK_TYPE.animal" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.animal?'bg-warning text-primary fw-bold':'text-secondary']">绝世欧皇[普通]</div>
                                        <div @click="currRuleType=MARK_TYPE.monk" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.monk?'bg-warning text-primary fw-bold':'text-secondary']">天选之子[噩梦]</div>
                                        <div @click="currRuleType=MARK_TYPE.weather" class="flex-grow-1 w-100 px-1 text-spacing-_1" :class="[currRuleType==MARK_TYPE.weather?'bg-warning text-primary fw-bold':'text-secondary']">无上先知[炼狱]</div>
                                    </div>
                                    <div class="d-flex flex-column flex-grow-1 mx-2 mx-sm-3">
                                        <div class="d-flex justify-content-between align-items-center text-light fw-bold py-2 border-bottom border-secondary">
                                            <div class="text-light" @click="isShowRule=true">
                                                <i class="bi bi-file-earmark-text-fill me-1"></i>规则<span class="d-none d-sm-inline">说明</span>
                                            </div>
                                            <div class="d-flex align-items-center">
                                                <span class="fs-4" :class="{'text-secondary':currRuleType!=userInfo.markType}">{{currRuleType==MARK_TYPE.animal?"十二生肖":currRuleType==MARK_TYPE.monk?"十八罗汉":"二十四节气"}}</span>
                                                <span v-if="currRuleType==userInfo.markType" class="rounded-pill small px-2 bg-secondary mx-2 text-warning">生效中</span>
                                                <span v-else class="rounded-pill small px-2 bg-warning mx-2" @click="setMarkType(false)">点击激活</span>
                                            </div>
                                            <i class="bi bi-x-octagon fs-5" @click="isShowMark=false"></i>
                                        </div>
                                        <div class="flex-grow-1 d-flex flex-column">
                                            <div class="flex-grow-1 d-flex flex-column flex-sm-row">
                                                <div class="d-flex justify-content-center align-items-center py-1 pb-2 py-sm-0">
                                                    <div class="position-relative fw-bold rounded-circle w-xs-4rem w-5rem d-flex justify-content-center align-items-center">
                                                        <img class="img-fluid" src="@/assets/images/room/bac/mark_count.png" alt="">
                                                        <span class="position-absolute fw-bold text-light start-50 translate-middle-x fs-5 pb-1">{{ currRuleType==userInfo.markType?(userInfo.mark||0):0 }}</span>
                                                        <span class="position-absolute bottom-xs-0 top-sm-100 rounded-pill bg-info small px-1 lh-xs-sm translate-50-y-xs">当前进度</span>
                                                    </div>
                                                </div>
                                                <div class="flex-grow-1 d-flex flex-wrap">
                                                    <div :class="[currRuleType==MARK_TYPE.animal?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-1 p-sm-2 position-relative align-items-center" v-for="i in 12" :key="i">
                                                        <div :class="[(userInfo.markType!=MARK_TYPE.animal||i>(userInfo.mark||0))?'':'animal-active']" class="rotate-y-180 transform-3d position-relative w-100 h-xs-0 flex-grow-1">
                                                            <div class="position-absolute top-0 start-0 w-100 h-100 rounded-5 fs-1 rotate-y-180 fw-bold d-flex justify-content-center align-items-center" :style="{background: 'url('+require('@/assets/images/room/bac/bg_style_1.jpg')+') no-repeat top left/100% 100%'}"></div>
                                                            <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1 p-1 backface-hidden" :src="require('@/assets/images/room/bac/12animal/'+i+'.png')" alt="">
                                                        </div>
                                                    </div>
                                                    <div :class="[currRuleType==MARK_TYPE.monk?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-0 p-sm-2 position-relative align-items-center" v-for="i in 18" :key="i">
                                                        <div :class="[(userInfo.markType!=MARK_TYPE.monk||i>(userInfo.mark||0))?'bg-dark index-1':'monk-active']" class="position-absolute w-100 h-100 bg-opacity-50 top-0 start-0"></div>
                                                        <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1" :src="require('@/assets/images/room/bac/18monk/'+i+'.png')" alt="">
                                                    </div>
                                                    <div :class="[currRuleType==MARK_TYPE.weather?'d-flex flex-column flex-sm-row':'d-none']" class="col-3 col-sm-2 p-1 p-sm-2 position-relative align-items-center" v-for="i in 24" :key="i">
                                                        <div :class="[(userInfo.markType!=MARK_TYPE.weather||i>(userInfo.mark)||0)?'bg-dark index-1':'weather-active']" class="position-absolute w-100 h-100 bg-opacity-50 top-0 start-0"></div>
                                                        <img class="img-sm-fluid position-relative h-xs-0 flex-grow-1" :src="require('@/assets/images/room/bac/24weather/'+i+'.jpg')" alt="">
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-sm-center fw-bold py-2 border-top border-secondary position-relative">
                                                <span @click="isShowMark=false" class="d-none d-sm-block bg-secondary rounded-pill px-3 py-1 mx-1 mx-sm-3">关闭</span>
                                                <span @click="setMarkType(true)" class="bg-danger rounded-pill px-3 py-1 mx-1 mx-sm-3">重置进度</span>
                                                <div class="d-flex align-items-center position-absolute end-0 top-50 translate-middle-y">
                                                    <span class="text-light me-1">最终返利：</span>
                                                    <span class="text-warning fs-3 fw-bold">{{markOdds[currRuleType-1]||0}}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                       
                        <!-- 池额 -->
                        <!-- <div class="position-absolute top-0 end-0 d-flex flex-column bg-dark text-light bg-opacity-50 px-3 py-1 rounded me-2 mt-2 mt-sm-5 fw-bold index-1">
                            <div class="text-center border-bottom">{{$t("video.pool")}}</div>
                            <div class="d-flex text-end small justify-content-between">
                                <div class="d-flex flex-column me-3 ms-2">
                                    <span :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                                    <span :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                    <span :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                                    <span v-if="roomInfo.game==GAME_ID.bac" :style="'color:'+COLOR.red">{{$t("common.zd")}}</span>
                                    <span v-if="roomInfo.game==GAME_ID.bac" :style="'color:'+COLOR.blue">{{$t("common.xd")}}</span>
                                </div>
                                <div class="d-flex flex-column me-2">
                                    <span :style="'color:'+COLOR.red">{{pool.z}}</span>
                                    <span :style="'color:'+COLOR.green">{{pool.h}}</span>
                                    <span :style="'color:'+COLOR.blue">{{pool.x}}</span>
                                    <span v-if="roomInfo.game==GAME_ID.bac" :style="'color:'+COLOR.red">{{pool.zd}}</span>
                                    <span v-if="roomInfo.game==GAME_ID.bac" :style="'color:'+COLOR.blue">{{pool.xd}}</span>
                                </div>
                            </div>
                        </div> -->
                    </div>
                </div>
                <!-- 选筹,下注区 -->
                <div class="d-flex flex-column position-relative" :class="{'flex-sm-row':!isMultiple,'order-2':isMultiple}">
                    <div class="d-flex flex-column justify-content-between" :class="{'order-2':isMultiple}" :style="{width: isMultiple?'':'50%'}">
                        <div :class="{'flex-sm-column':!isMultiple,'flex-sm-column-reverse':isMultiple}" class="d-flex flex-column px-1 px-sm-0">
                            <!-- 台面列表 -->
                            <div class="d-flex align-items-center table-list-ul rounded-3 mb-xl-2 mb-sm-1 mx-1 px-1 mt-2" :class="{'d-none':isMultiple}">
                                <div @click="roomListStartPage>0&&roomListStartPage--"><img class="img-fluid start-0" src="@/assets/images/room/table_l01.png"></div>
                                <ul class="pagination d-flex w-100 align-items-center flex-grow-1 mb-0">
                                    <li @click="$root.goRoom(item.id,item.game)" @mouseenter="showHoverRoomPearl(item)" @mouseleave="currHoverRoom=null" v-for="(item,l) in roomList.slice(roomListStartPage*10,(roomListStartPage+1)*10)" :key="(item,l)" class="position-relative page-item mx-1 rounded-circle overflow-hidden">
                                        <img class="img-fluid w-3_5rem start-0" src="@/assets/images/room/table_ballbj.png" style="transform: scale(1, 0.85);">
                                        <div class="position-absolute start-50 top-50 translate-middle text-center lh-1 h-100 d-flex flex-column justify-content-center text-nowrap">
                                            <span style="font-size: .6rem;">{{ item.room.substr(0,item.room.indexOf('厅'))+ (item.game==1?"百":"龙") }}</span>
                                            <span class="fw-bold">{{ item.table.replace(/[^\d.]/g, '') }}</span>
                                        </div>
                                    </li>
                                </ul>
                                <div @click="roomListStartPage<Math.ceil(roomList.length/10)-1&&roomListStartPage++"><img class="img-fluid start-0" src="@/assets/images/room/table_r01.png"></div>
                            </div>
                            <!-- 选筹区 -->
                            <div class="d-flex align-items-center text-black order-2 order-sm-1 flex-grow-1 col position-relative" :class="{'multiplebg mb-0':isMultiple,'mb-xl-2 mb-sm-1':!isMultiple}">
                                <span class="table-name d-flex px-2 py-1 fs-4 mx-xl-2 mx-sm-1 rounded-3 text-nowrap" :class="{'d-none':isMultiple}">{{roomInfo.table}}台</span>
                                <div class="d-flex rounded-3 justify-content-between justify-content-sm-around align-items-center flex-grow-1" :class="{'chips-bg':!isMultiple}">
                                    <div @click.stop="showMoreAmount(roomInfo.id)" class="text-light mx-2" style="transform: rotateX(40deg);">
                                        <img class="w-4rem rounded-circle chips-shadow" :src="require('@/assets/images/room/bet/sbetbtn.png')" alt="">
                                    </div>
                                    <div v-for="item in currAmountList.find(v=>v.id==roomInfo.id)?currAmountList.find(v=>v.id==roomInfo.id).amount:defaultAmountList" :key="item" class="d-flex justify-content-around align-items-center col">
                                        <div class="position-relative chips rounded-circle my-1" :class="{active:amount==item}" @click="amount=item" role="button" style="transform: rotateX(40deg);">
                                            <img class="w-4rem rounded-circle chips-shadow" :src="require('@/assets/images/room/bet/chips_'+item+'.png')" alt="">
                                        </div>
                                    </div>
                                    <div class="position-relative chips rounded-circle my-1 mx-2"  style="transform: rotateX(40deg);">
                                        <img class="w-4rem rounded-circle chips-shadow" src="@/assets/images/room/bet/chips_Infinity.png" alt="">
                                    </div>
                                </div>
                                <div v-if="showMoreAmountRoomIdArr.find(v=>v.id==roomInfo.id)" class=" position-absolute start-50 top-50 translate-middle-x rounded-3 d-flex flex-column index-2">
                                    <span class="text-warning fs-5 text-center border border-warning lh-1 cmdiy-tit">自定筹码</span>
                                    <div class="d-flex flex-column cmdiy-con">
                                        <div class="d-flex flex-column px-3">
                                            <div class="d-flex justify-content-between my-2">
                                                <div v-for="i in AMOUTN_ARR.slice(0,5)" :key="i" @click="setRoomAmountList(roomInfo.id,i)" class="position-relative ms-3 me-3 ms-sm-0 me-sm-1 chips rounded-circle" role="button">
                                                    <img class="w-3rem rounded-circle chips-shadow" :class="{'border border-3 border-warning':showMoreAmountRoomIdArr.find(v=>v.id==roomInfo.id).amountArr.find(v=>v==i)}" :src="require('@/assets/images/room/bet/chips_'+i+'.png')" alt="">
                                                </div>
                                            </div>
                                            <div class="d-flex justify-content-between my-2">
                                                <div v-for="i in AMOUTN_ARR.slice(5)" :key="i" @click="setRoomAmountList(roomInfo.id,i)" class="position-relative ms-3 me-3 ms-sm-0 me-sm-1 chips rounded-circle" role="button">
                                                    <img class="w-3rem rounded-circle chips-shadow" :class="{'border border-3 border-warning':showMoreAmountRoomIdArr.find(v=>v.id==roomInfo.id).amountArr.find(v=>v==i)}" :src="require('@/assets/images/room/bet/chips_'+i+'.png')" alt="">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex justify-content-evenly mb-1">
                                            <button type="button" class="btn cmdiy-btn text-light px-3" @click="saveAmount(roomInfo.id)">保存</button>
                                            <button type="button" class="btn cmdiy-btn text-light px-3" @click="this.showMoreAmountRoomIdArr.splice(this.showMoreAmountRoomIdArr.findIndex(v=>v==(isMultiple?getBetRoomList[i-1].id:roomInfo.id)),1)">取消</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- 按钮区 -->
                            <div v-if="!isMultiple" style="width: 100%;" class="d-flex text-nowrap order-3 mb-1 mb-sm-1 ms-sm-1 flex-grow-1 position-relative" >
                                <div class="text-light mx-xl-3 mx-sm-1" @click="$root.logout">
                                    <img class="w-3rem rounded-circle chips-shadow" src="@/assets/images/room/outGameBtn02.png" alt="">
                                </div>
                                <div class="d-flex rounded-3 btn-bg justify-content-between align-items-center col" :class="{'justify-content-sm-around':!isMultiple}">
                                    <button class="text-light px-sm-1 px-xl-2 feedback rounded-3 fw-bold me-xl-2 me-sm-1"  @click="$root.setCurrModal($t('common.questionFeedBack'))">问题反馈</button>
                                    <div class="d-flex">
                                        <button class="px-sm-1 px-xl-3 rounded-3 btnbg fw-bold me-xl-2 me-sm-1" :class="{'disabled':!canCancel}" :disabled="!canCancel" @click="submitEvent('cancel')">{{$t("room.cancel")}}投注</button>
                                        <button class="px-sm-1 px-xl-3 rounded-3 btnbg fw-bold me-xl-2 me-sm-1" :class="{'disabled':!canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">{{$t("room.confirm")}}投注</button>
                                        <button class="px-sm-1 px-xl-3 rounded-3 btnbg fw-bold me-xl-2 me-sm-1" :class="{'disabled':!canAgain}" :disabled="!canAgain" @click="submitEvent('again')">重复投注</button>
                                    </div>
                                    
                                    <button class="text-light px-sm-3 clearbg rounded-3" :class="{'disabled':!canClear}" :disabled="!canClear" @click="submitEvent('clear')">{{$t("room.clear")}}</button>
                                    <div v-if="roomInfo.iscommission==IS_REBATE.true" @click="setRebate($event)" class="w-4rem d-flex align-items-center index-1">
                                        <img v-if="currRebate!=REBATE_TYPE.noRebate" class="w-100" src="@/assets/images/room/mStyle01.png" alt="">
                                        <img v-else class="w-100" src="@/assets/images/room/mStyle02.png" alt="">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-column flex-grow-1 position-relative" :class="{'order-1':isMultiple}">
                        <!-- 提交区 -->
                        <div class="position-xs-relative start-0 end-0 bottom-0 top-0" :class="{'flex-grow-1 d-flex order-1':isMultiple}">
                            <!-- 背景色(因内联样式无法使用媒体查询所以这么写) -->
                            <div class="position-absolute w-100 h-100 d-sm-none" :style="{'background':roomInfo.bgcolor}"></div>
                            <!-- 操作区 -->
                            <div v-if="gameModel==GAME_MODEL.normal" class="position-xs-relative bottom-0 index-1" :class="{'perspective-600':!isMultiple,'flex-grow-1 d-flex':isMultiple,'scale-submit':isScale==true}">
                                <div class="pb-1 pb-sm-0" :class="{'flex-grow-1 d-flex mb-sm-0 mb-md-0':isMultiple,'mb-sm-2 me-1 mt-sm-1 mt-md-2':!isMultiple}">
                                    <div class="d-flex flex-column" :class="{'flex-grow-1':isMultiple,'flex-sm-row align-items-sm-end justify-content-center':!isMultiple}">
                                        <div class="d-flex flex-column flex-grow-1" :class="{'flex-sm-row':!isMultiple}">
                                            <!-- 切换区 -->
                                            <div class="d-flex flex-column flex-grow-1 flex-column-reverse flex-sm-column-reverse" :class="{'flex-sm-column-reverse':isMultiple}">
                                                
                                                <!-- 提交区 -->
                                                <div :class="{'flex-grow-1 align-items-sm-stretch':isMultiple,'bet-border':!isMultiple,'mb-sm-0':isMultiple}" class=" d-flex flex-wrap justify-content-center align-items-sm-end align-items-lg-stretch position-relative order-1 order-sm-2 text-center mb-2">
                                                    
                                                    <!-- xd -->
                                                    <div v-if="(isMultiple?roomList.find(v=>v.id==getBetRoomList[i-1].id).game:roomInfo.game)==GAME_ID.bac" class="bet-submit d-flex col-4 justify-content-center border-solid border-xs border-end-xs-0 border-bottom-xs-0 border-end-0 border-bottom-sm-0 border-light position-relative flex-grow-1 overflow-hidden" :class="{' border-0 col-sm-4 order-sm-1  border-sm-2':!isMultiple,'flex-column border border-1 border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('xd')!=-1,'layer-absolute':odds.xd==0&&!isMultiple}" @click="addAmount('xd',$event)">
                                                        <div v-show="pool.xd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 71, 133,.5)',height: pool.xd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%'}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{pool.xd}}</span>
                                                        </div>
                                                        <div class="small text-white-50 text-nowrap align-content-center" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div class="ffen" :class="{'fs-4':!isMultiple}" style="color:#FFFE35">P.PAIR</div>
                                                            <div :class="{'d-none':isMultiple}">1:{{odds.xd}}</div>
                                                        </div>
                                                        <span class="fs-2 fw-bold d-flex flex-column justify-content-center text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-2 mx-md-2 py-sm-1 py-xl-2']" :style="{'color':COLOR.blueDark}">{{$t("common.xd")}}</span>
                                                        <div v-for="j,index in chipsConvert(submited.xd+submiting.xd)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.xd}">
                                                                <small class="text-shadow-white">{{submited.xd+submiting.xd>0?submited.xd+submiting.xd:''}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- h -->
                                                    <div class="bet-submit d-flex col-4 flex-column justify-content-center border-solid border-xs border-end-xs-0 border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-top-sm-0':!isMultiple,'flex-column border bg-success':isMultiple,'border-bottom-0':roomInfo.game==GAME_ID.bac,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('h')!=-1,'order-sm-2':roomInfo.game==GAME_ID.bac&&!isMultiple,'order-2':roomInfo.game!=GAME_ID.bac,'border-bottom-xs-0':roomInfo.game==GAME_ID.bac,'layer-absolute':odds.h==0&&!isMultiple}" @click="addAmount('h',$event)">
                                                        <div class="d-flex justify-content-center" :class="{'flex-column':isMultiple}">
                                                            <div v-show="pool.h>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 170, 0,.5)',height: pool.h/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.green}">
                                                                <span class="position-absolute top-0 translate-end-y index-1">{{ pool.h }}</span>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-1 lh-2-4 my-2 my-sm-0 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-2 mx-md-2 px-sm-2 py-sm-1 py-xl-2':'fs-1 mx-sm-2 mx-lg-2 py-sm-1 py-xl-2 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.green">{{$t("common.h")}}</span>
                                                            <div class="small text-white-50 text-nowrap align-content-center">
                                                                <div class="ffen" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">TIE</div>
                                                                <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{odds.h}}</div>
                                                            </div>
                                                            <div v-for="j,index in chipsConvert(submited.h+submiting.h)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                                <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                                <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                            </div>
                                                            <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                                <span class="d-block small scale" :class="{'scale-2':isScaleAmount.h}">
                                                                    <small class="d-block text-shadow-white">{{submited.h+submiting.h>0?submited.h+submiting.h:''}}</small>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <!--- 倒计时 -->
                                                        <div class="countdown justify-content-between align-items-center m-xl-2 mx-sm-1" :class="[roomInfo.game==GAME_ID.lh&&!isMultiple?'d-flex border-solid border-1 border-light border-top-1':'d-none']">
                                                            <div class="small text-white-50 text-nowrap align-content-center ps-xl-4 " :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="text-black fw-bold" :class="{'fs-6':!isMultiple}" >剩余押注时间</div>
                                                                <div class="text-black fw-bold">TIME</div>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-light countdown-time m-xl-1 rounded-3 w-4rem" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-1 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-0 mx-xl-2 m-1':'fs-2 mx-sm-2')]" :style="'color:'+COLOR.blue">{{roomInfo.countdown}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- zd -->
                                                    <div v-if="isMultiple?roomList.find(v=>v.id==getBetRoomList[i-1].id).game==GAME_ID.bac:roomInfo.game==GAME_ID.bac" class="bet-submit d-flex col-4 justify-content-center border-solid border-xs border-bottom-xs-0 border-bottom-sm-0 border-start-0 border-light position-relative flex-grow-1" :class="{'col-sm-4 order-sm-2 border-sm-2 border-top-sm-0 border-end-0':!isMultiple,'flex-column border border-bottom-0 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('zd')!=-1,'layer-absolute':odds.zd==0&&!isMultiple}" @click="addAmount('zd',$event)">
                                                        <div v-show="pool.zd>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 0, 0,.5)',height: pool.zd/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100+'%',color:COLOR.redDark}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.zd }}</span>
                                                        </div>
                                                        <span class="fs-2 fw-bold d-flex flex-column justify-content-center text-nowrap text-shadow-white" :class="[isMultiple?'my-sm-0 my-lg-1 lh-sm-1':'mx-sm-2 py-sm-1 py-xl-2']" :style="'color:'+COLOR.redDark">{{$t("common.zd")}}</span>
                                                        <div class="small text-white-50 text-nowrap align-content-center" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                            <div class="ffen" :class="{'fs-4':!isMultiple}" style="color:#FFFE35">B.PAIR</div>
                                                            <div :class="{'d-none':isMultiple}">1:{{odds.zd}}</div>
                                                        </div>
                                                        <div v-for="j,index in chipsConvert(submited.zd+submiting.zd)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.zd}">
                                                                <small class="d-block text-shadow-white">{{submited.zd+submiting.zd>0?submited.zd+submiting.zd:''}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- x -->
                                                    <div class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'flex-column border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('x')!=-1,'order-sm-2 col-4 border-end-xs-0':roomInfo.game==GAME_ID.bac,'border-end-0':roomInfo.game==GAME_ID.bac,'col-4 order-3':roomInfo.game!=GAME_ID.bac,'layer-absolute':odds.x==0&&!isMultiple}" @click="addAmount('x',$event)">
                                                        <div v-show="pool.x>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(0, 105, 197,.5)',height: (pool.x/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.blue}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.x }}</span>
                                                        </div>
                                                        <div class="small text-white-50 text-nowrap align-content-center">
                                                            <div class="ffen" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">{{roomInfo.game==GAME_ID.lh?'TIGER':'PLAYER'}}</div>
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.x:1}}</div>
                                                        </div>
                                                        <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-1 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-2 px-sm-2 py-sm-1 py-xl-5':'fs-1 mx-sm-2 py-sm-1 py-xl-2 px-sm-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.blue">{{$root.getTextByGame("common.",roomInfo.game,1)}}</span>
                                                        <div v-for="j,index in chipsConvert(submited.x+submiting.x)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.x}">
                                                                <small class="d-block text-shadow-white">{{submited.x+submiting.x>0?submited.x+submiting.x:''}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <!-- time -->
                                                    <div v-if="roomInfo.game==GAME_ID.bac&&!isMultiple" class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('x')!=-1,'order-sm-2 col-6 border-end-xs-0':roomInfo.game==GAME_ID.bac,'border-end-0':roomInfo.game==GAME_ID.bac&&isMultiple,'col-4 order-3':roomInfo.game!=GAME_ID.bac,'me-sm-2':roomInfo.game!=GAME_ID.bac&&!isMultiple,'layer-absolute':odds.x==0}" @click="addAmount('x',$event)">
                                                        <div class="countdown d-flex justify-content-between m-xl-2 my-sm-1 align-items-center">
                                                            <div class="small text-white-50 text-nowrap align-content-center ps-xxl-4" :class="[isMultiple?'lh-sm-1 lh-xl-2':'']">
                                                                <div class="text-black fw-bold" :class="{'fs-6':!isMultiple}" >剩余押注时间</div>
                                                                <div class="text-black fw-bold ffen">TIME</div>
                                                            </div>
                                                            <span class="fw-bold d-flex flex-column justify-content-center text-light countdown-time m-1 rounded-3 w-4rem" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-2 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-2 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-2':'fs-2 mx-sm-0 mx-xl-2')]" :style="'color:'+COLOR.blue">{{roomInfo.countdown}}</span>
                                                        </div>
                                                    </div>
                                                    <!-- z -->
                                                    <div class="bet-submit d-flex justify-content-center border-solid border-xs border-light position-relative flex-grow-1" :class="{'col-sm-4 border-sm-2 border-bottom-sm-0':!isMultiple,'flex-column border-1 bg-success':isMultiple,'coruscate':coruscateArr.find(v=>v.id==roomInfo.id)&&coruscateArr.find(v=>v.id==roomInfo.id).coruscate.indexOf('z')!=-1,'order-sm-4 col-4':roomInfo.game==GAME_ID.bac,'col-4 order-1 border-end-xs-0':roomInfo.game!=GAME_ID.bac,'border-start-0':roomInfo.game==GAME_ID.bac&&!isMultiple,'border-end-0':roomInfo.game!=GAME_ID.bac&&isMultiple,'layer-absolute':odds.z==0&&!isMultiple}" @click="addAmount('z',$event)">
                                                        <div v-show="pool.z>0" class="position-absolute w-100 bottom-0 index-_1 text-start small text-shadow-white fw-bold" :style="{background:'rgb(255, 40, 40,.5)',height: (pool.z/(Number(pool.z)+Number(pool.x)+Number(pool.h)+Number(pool.zd)+Number(pool.xd))*100).toFixed(2)+'%',color:COLOR.red}">
                                                            <span class="position-absolute top-0 translate-end-y index-1">{{ pool.z }}</span>
                                                        </div>
                                                        <span class="fw-bold d-flex flex-column justify-content-center text-shadow-white" :class="[roomInfo.game==GAME_ID.lh?'fs-xs-2 fs-sm-2 lh-2-4 my-2 my-sm-0 fs-1 lh-4 lh-sm-base border-sm-0':'',isMultiple?(roomInfo.game==GAME_ID.lh?'fs-xs-2 h1-sm lh-2-4 my-2 my-sm-0 my-lg-2':'fs-1 my-sm-0 my-lg-1 lh-sm-1'):(roomInfo.game==GAME_ID.lh?'mx-sm-2 px-sm-2':'fs-1 mx-sm-2 py-sm-2 py-sm-1 py-xl-2 px-md-3 px-lg-0')]" :style="'color:'+COLOR.red">{{$root.getTextByGame("common.",roomInfo.game,0)}}</span>
                                                        <div class="small text-white-50 text-nowrap align-content-center">
                                                            <div class="ffen" :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'lh-xs-3 lh-sm-2 lh-xl-4':'lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'fs-3':'fs-4')]" style="color:#FFFE35">{{roomInfo.game==GAME_ID.lh?'DRAGON':'BANKER'}}</div>
                                                            <div :class="[roomInfo.game==GAME_ID.lh?'lh-xs-3':'',isMultiple?(roomInfo.game==GAME_ID.lh?'d-none lh-xs-3 lh-sm-2 lh-xl-4':'d-none lh-sm-1 lh-xl-2'):(roomInfo.game==GAME_ID.lh?'':'')]">1:{{currRebate==REBATE_TYPE.rebate?odds.z:1+(roomInfo.game==GAME_ID.bac?'('+$t("room.rebateTxt")+')':'')}}</div>
                                                        </div>
                                                        <div v-for="j,index in chipsConvert(submited.z+submiting.z)" :key="j" :style="'bottom:'+(2*index)+'px !important'" class="position-absolute start-50 translate-middle-x fs-6 mb-4 text-black" :class="{'chips-img-shadow':index==0}">
                                                            <img class="w-2_5rem rounded-circle" :src="require('@/assets/images/room/chips_'+j+'.png')" alt="">
                                                            <span class="position-absolute start-50 top-50 fw-bold chips-text small">{{$root.chipsTxtConvert(j)}}</span>
                                                        </div>
                                                        <div class="position-absolute start-50 translate-middle-x text-black fw-bold fs-6 bottom-0">
                                                            <span class="d-block small scale" :class="{'scale-2':isScaleAmount.z}">
                                                                <small class="d-block text-shadow-white">{{submited.z+submiting.z>0?submited.z+submiting.z:''}}</small>
                                                            </span>
                                                        </div>
                                                    </div>
                                                    
                                                    <!-- 更多筹区 -->
                                                    <change-amount :class="{'rounded-sm-10':!isMultiple}" :is-show="isShowMoreAmount"></change-amount>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- 按钮区 -->
                                        <div v-if="isMultiple" class="d-flex justify-content-evenly text-nowrap order-3 mb-1 mb-sm-0 px-1" :class="{'ps-sm-0 pe-sm-2 pt-1 multiplebg':isMultiple,'justify-content-sm-around px-sm-0 ms-sm-1 py-1':!isMultiple}">
                                            <div :class="{'d-sm-none':!isMultiple}" class="d-none form-check form-switch d-flex align-items-center border border-1 border-secondary rounded p-1 mb-0">
                                                <label class="me-1 text-light" for="cboRebateNewXs">{{$t("room.unRebate")}}</label>
                                                <input class="form-check-input fs-3 m-0" type="checkbox" id="cboRebateNewXs" @change="setRebate($event)" :checked="currRebate==REBATE_TYPE.noRebate">
                                            </div>
                                            <span class="fw-bold fs-2 text-center text-red">{{roomList.find(v=>v.id==getBetRoomList[i-1].id).countdown}}</span>
                                            <div type="button" class="text-light" :class="{'disabled':!canClear}" :disabled="!canClear" @click="submitEvent('clear')">
                                                <img class="w-3rem" src="@/assets/images/room/many_clearbtn01.png" alt="">
                                            </div>
                                            <div type="button" class="text-light" :class="{'disabled':!canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">
                                                <img class="w-3rem" src="@/assets/images/room/many_reap01.png" alt="">
                                            </div>
                                            <div type="button" class="text-light" :class="{'disabled':!canConfirm}" :disabled="!canConfirm" @click="submitEvent('confirm')">
                                                <img class="w-3rem" src="@/assets/images/room/many_sure01.png" alt="">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>       
    
                <!-- 路单统计区 -->
                <div v-if="!isMultiple" class="d-flex flex-wrap justify-content-between text-light small bg-gradient position-relative">
                    <div class="d-flex">
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">第</span>
                            <span class="bg-black w-3rem text-center">{{roomInfo.boot}}</span>
                            <span class="px-1">靴</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">第</span>
                            <span class="bg-black w-3rem text-center">{{roomInfo.innings}}</span>
                            <span class="px-1">局</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">庄</span>
                            <span class="bg-black w-2rem text-center me-1">{{pearlCount?pearlCount.z:0}}</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">闲</span>
                            <span class="bg-black w-2rem text-center me-1">{{pearlCount?pearlCount.x:0}}</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">和</span>
                            <span class="bg-black w-2rem text-center me-1">{{pearlCount?pearlCount.h:0}}</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">庄对</span>
                            <span class="bg-black w-2rem text-center">{{pearlCount?pearlCount.zd:0}}</span>
                        </div>
                        <div class="d-flex border-end border-dark">
                            <span class="px-1">闲对</span>
                            <span class="bg-black w-2rem text-center">{{pearlCount?pearlCount.xd:0}}</span>
                        </div>
                        <div class="d-flex col-12 col-sm-auto fw-bold">
                            <div class="ps-2 col-6 col-sm-auto d-flex">
                                <span class="text-danger">{{$root.getTextByGame("room.next",roomInfo.game,0)}}：</span>
                                <label class="d-flex align-items-center text-transparent">
                                    <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextZHollowStyle"></span>
                                    <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextZBevelStyle"></span>
                                    <span class="rounded-circle w-1rem h-1rem border-3" :style="nextZSolidStyle"></span>
                                </label>
                            </div>
                            <div class="ps-2 col-6 col-sm-auto d-flex justify-content-end">
                                <span :style="'color:'+COLOR.blue">{{$root.getTextByGame("room.next",roomInfo.game,1)}}：</span>
                                <label class="d-flex align-items-center text-transparent">
                                    <span class="rounded-circle w-1rem h-1rem border-2 border-solid me-2" :style="nextXHollowStyle"></span>
                                    <span class="h-1rem border-1 border-top-0 border-left-0 border-bottom-0 rotate-30 border-solid me-2" :style="nextXBevelStyle"></span>
                                    <span class="rounded-circle w-1rem h-1rem border-3" :style="nextXSolidStyle"></span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex">
                        <button class="px-sm-1 px-xxl-3 rounded-3 btnbg fw-bold small" @click="nextPrediction(roomInfo.game==GAME_ID.bac?'A':'M')">庄问路</button>
                        <button class="px-sm-1 px-xxl-3 rounded-3 btnbg fw-bold small" @click="nextPrediction(roomInfo.game==GAME_ID.bac?'B':'N')">闲问路</button>
                        <button class="px-sm-1 px-xxl-3 rounded-3 btnbg fw-bold small" @click="$root.setCurrModal($t('common.userRecords'))">下注记录</button>
                    </div>
                    <div v-if="currHoverRoom" class="d-flex position-absolute top-0 end-0 index-1 p-1 bg-light bg-opacity-75" style="width: 65rem;height: 10rem; box-shadow: 0 0 .2rem 0 #000;">
                        <div class="w-100 h-100 ">
                            <canvas :id="'bigPearl_'+(currHoverRoom?currHoverRoom.id:'')" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100 bg-light bg-opacity-25 border border-secondary" v-set-size="6" data-canvas-room="6" width="0" height="0"></canvas>
                        </div>
                        <span class="position-absolute top-50 start-50 translate-middle fw-bold display-1 text-dark">{{ roomList.find(v=>v.id==currHoverRoom.id).countdown }}</span>
                    </div>
                </div>
                <!-- 路单区 -->
                <div v-if="!isMultiple" class="flex-grow-1 d-flex h-0 position-relative" :class="[(gameModel==GAME_MODEL.normal)?'flex-sm-grow-1  ':'overflow-hidden']">
                    <!-- 问路 -->
                    <!-- <div class="d-flex flex-column text-light text-center w-2rem text-nowrap small">
                        <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'A':'M')" :style="'background:'+COLOR.red+';border-color:'+COLOR.red" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,0)}}</div>
                        <div @click="nextPrediction(roomInfo.game==GAME_ID.bac?'B':'N')" :style="'background:'+COLOR.blue+';border-color:'+COLOR.blue" class="d-flex justify-content-center align-items-center col text-vertical small bg-highlight border-_3 border-style-outset" role="button">{{$root.getTextByGame("room.will",roomInfo.game,1)}}</div>
                    </div> -->
                    <!-- 路单 -->
                    <div :class="{'flex-sm-nowrap':pearlModel==1,'flex-column':pearlModel==2}" class="flex-grow-1 d-flex flex-wrap w-0">
                        <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-3 h-sm-100':pearlModel==2}" class="position-relative">
                            <canvas id="textBigPearl" class="bg-light d-block mx-auto min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0" @mousemove.stop="showPoker($event,1)"></canvas>
                            <div class="bg-dark bg-opacity-25 position-absolute" :style="pearlLayerStyle" @mouseout.stop="showPoker($event,0)"></div>
                            <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                <div class="d-flex flex-column justify-content-center">
                                    <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_text)" role="button"></i>
                                </div>
                            </div>
                            <!-- 牌区 -->
                            <div v-if="showPokerArr.length>0" class="d-flex position-absolute top-0 start-100 index-1 w-xs-100 h-xs-100 align-items-center align-items-sm-start justify-content-center justify-content-sm-start bg-xs-dark bg-opacity-25 rounded-sm-10 text-start">
                                <div v-for="(item,i) in showPokerArr" :key="item" :class="[roomInfo.game==GAME_ID.bac?'order-'+(showPokerArr.length-i):'']" :style="{'background':(i==0?'linear-gradient('+(roomInfo.game==GAME_ID.bac?90:270)+'deg,#910000, rgb(251, 36, 1) 40%)':'linear-gradient('+(roomInfo.game==GAME_ID.bac?270:90)+'deg,#00315d,rgb(0, 105, 197) 40%)')}" class="d-flex flex-column rounded">
                                    <div class="text-light text-center fw-bold rounded position-relative pt-1 fs-xs-5">
                                        <span>{{roomInfo.game==GAME_ID.bac?i==0?$t("common.z"):$t("common.x"):i==0?$t("common.l"):$t("common.hu")}}</span>
                                        <i class="position-absolute fw-bold fs-xs-1 fs-sm-4 lh-1" :class="{'end-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'start-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}" :style="{'color':i==0?COLOR.red:COLOR.blue}">{{ roomInfo.game==GAME_ID.bac?(i==0?'S':'V'):(i==0?'V':'S') }}</i>
                                        <span v-if="isPokerWin(i)&&isShowPokerCompare" class="bi bi-trophy-fill text-yellow position-absolute translate-middle-y top-50 big-scale-small fs-xs-1 fs-sm-4" :class="{'start-0':(roomInfo.game==GAME_ID.bac&&i!=0)||(roomInfo.game!=GAME_ID.bac&&i==0),'end-0':(roomInfo.game==GAME_ID.bac&&i==0||roomInfo.game!=GAME_ID.bac&&i!=0)}"></span>
                                    </div>
                                    <div class="rounded p-1 d-flex flex-wrap justify-content-between align-content-around position-relative w-10rem w-sm-7rem h-11rem h-sm-8rem">
                                        <!-- 牌 -->
                                        <div v-for="(val,j) in item" :key="val" class="d-flex align-items-center justify-content-center" :class="[item.length==3&&j==2?'w-100 order-1':'order-2']">
                                            <div v-if="val" :class="[$root.getPokerByNum(val)['color'],((i+1)==currPokerXY[0]&&(j+1)==currPokerXY[1])?'rotate':'',j==2?'':'flex-column']" class="d-flex bg-light rounded p-1">
                                                <span class="fw-bold lh-1 fs-xs-5 small" :class="{'order-1 text-vertical':j==2}">{{ $root.getPokerByNum(val)["name"] }}</span>
                                                <div class="d-flex flex-grow-1" :class="[j==2?'py-3 py-sm-2 pe-2 pe-sm-1 ps-3 ps-sm-2':'px-3 px-sm-2 pt-2 pt-sm-1 pb-3 pb-sm-2']">
                                                    <i :class="[$root.getPokerByNum(val)['shape'],j==2?'rotate-90':'']" class="bi d-flex align-items-center justify-content-center fs-xs-1 fs-sm-4 flex-grow-1"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="isShowPokerCompare" class="position-absolute top-50 start-50 translate-middle init-rotate-345 border-double border-dark px-1 rounded fw-bold text-nowrap big-scale-small">{{ getPoint(item) }}点</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div :class="{'col-6 col-sm-3 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="position-relative">
                            <canvas id="bigPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="6" data-canvas-room="6" width="0" height="0"></canvas>
                            <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                <div class="d-flex flex-column justify-content-center">
                                    <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_hollow)" role="button"></i>
                                </div>
                            </div>
                        </div>
                        <div :class="{'col-12 col-sm-6 h-xs-50 h-sm-100':pearlModel==1,'h-xs-33 col-sm-9 h-sm-50':pearlModel==2}" class="d-flex flex-column">
                            <div class="d-flex h-50">
                                <div class="col-6 position-relative">
                                    <canvas id="smallHollowPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_hollow)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 position-relative">
                                    <canvas id="smallSolidPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.small_solid)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex h-50">
                                <div class="col-6 position-relative">
                                    <canvas id="bevelPearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.bevel)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-6 position-relative">
                                    <canvas id="threePearl" class="bg-light d-block min-w-100 min-h-100 mw-100 mh-100" v-set-size="3" data-canvas-room="3" width="0" height="0"></canvas>
                                    <div v-if="isShowPearlMoreLayer" class="d-flex justify-content-center bg-dark bg-opacity-75 position-absolute top-0 start-0 w-100 h-100 text-light hover-bg-opacity-50">
                                        <div class="d-flex flex-column justify-content-center">
                                            <i class="d-flex bi bi-arrows-fullscreen p-2 fs-5" @click="showMorePearl(PEARL_TYPE.big_three)" role="button"></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- 功能 -->
                    <div class="d-none flex-column flex-sm-row small text-light">
                        <!-- 切换模式 -->
                        <div v-if="!isShowPearlMoreLayer" class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="pearlModel=pearlModel==1?2:1" role="button">
                            <i class="bi bi-arrow-left-right lh-1 mb-lg-1"></i>
                            <div class="d-flex flex-column align-items-center">
                                <span class="text-vertical">{{$t('room.toggleMode')}}</span>
                            </div>
                        </div>
                        <!-- 查看全部按钮 -->
                        <div class="col d-flex flex-column justify-content-center align-items-center px-1 bg-dark bg-opacity-75 border-_3 border-style-outset border-dark small bg-gradient" @click="isShowPearlMoreLayer=!isShowPearlMoreLayer" role="button">
                            <i v-show="!isShowPearlMoreLayer" class="bi bi-search lh-1 mb-lg-1"></i>
                            <i v-show="isShowPearlMoreLayer" class="bi bi-x-octagon lh-1 mb-lg-1"></i>
                            <div class="d-flex flex-column align-items-center">
                                <span v-show="!isShowPearlMoreLayer" class="text-vertical">{{$t("room.viewAll")}}</span>
                                <span v-show="isShowPearlMoreLayer" class="text-vertical">{{$t("common.close")}}</span>
                            </div>
                        </div>
                    </div>
                    <!-- 查看所有路单 -->
                    <div :class="{'d-none':pearlMoreType==null}" class="position-absolute start-0 top-0 w-100 h-100">
                        <div class="w-100 h-100 bg-light">
                            <canvas id="fullPearl" v-move-x class="bg-light d-block min-w-100 min-h-100 mh-100 position-absolute end-0" width="0" height="0"></canvas>
                        </div>
                        <div class="position-absolute top-50 start-0 translate-middle-y p-2">
                            <i class="bi bi-caret-left-square-fill opacity-50 fs-1" @click="movePearlMore(-1)" role="button"></i>
                        </div>
                        <div class="position-absolute top-50 end-0 translate-middle-y p-2">
                            <i class="bi bi-caret-right-square-fill opacity-50 fs-1" @click="movePearlMore(1)" role="button"></i>
                        </div>
                        <div class="position-absolute bottom-0 start-50 translate-middle-x p-2">
                            <i class="d-flex bi bi-x-circle-fill opacity-75 fs-2" @click="pearlMoreType=null" role="button"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 音效 -->
        <audio-player v-show="false" ref="resultAudioPlayer" :isLoop="false" :isAutoPlayNext="false" :muted="!audioSwitch.resultAudio" :audio-list="resultAudioList.map(elm => elm.url)" />
        
        <footer v-if="isMultiple" class="d-flex justify-content-between mulbg-footer">
            <div class="d-flex justify-content-between align-items-center">
                <span class="text-light px-1 ms-1 small">会员账号：</span>
                <span class="footer-info px-5 small">{{userInfo.id}}</span>
                <span class="text-light px-1 ms-1 small">可用余额：</span>
                <span class="footer-info px-5 small">{{userInfo.realCoin}}</span>
            </div>
            <div class="d-flex justify-content-between align-items-center">
                <span class="btnbg rounded-3 fw-bold small px-3 me-1" @click="$root.setFullscreen">全屏缩放</span>
                <span class="btnbg rounded-3 fw-bold small px-3 me-1" @click="$root.setCurrModal($t('nav.sound'))">背景音乐</span>
                <span class="btnbg rounded-3 fw-bold small px-3 me-1" @click="$root.goPage('home')">返回大厅</span>
                <span class="btnbg rounded-3 fw-bold small px-3 me-1" @click="$root.logout">离开</span>
            </div>
        </footer>
    </div>
</template>
<script>
import {COMMAND,COLOR, GAME_ID,PEARL_TYPE,PEARL_CODE,REBATE_TYPE,IS_DEBUG,LAYER_TYPE,SUBMIT_RESULT,CANCEL_RESULT, IS_REBATE,RESULT,RATIO,AMOUTN_ARR,MUTATION_TYPE,GAME_CODE, GAME_MODEL,MARK_TYPE,RULE_TYPE, POKER_TYPE} from "@/assets/js/config.js"
import mediaVideo from "@/components/public/video.vue";
import roomList from '@/components/public/roomList.vue';
import navbarVertical from '@/components/public/navbarVertical.vue';
import navbar from '@/components/public/navbar.vue';
import notice from '@/components/public/notice.vue';
import changeRoom from '@/components/public/changeRoom.vue'
import changeAmount from '@/components/public/changeAmount.vue'
import { useLayer } from '@/assets/js/useLayer';
import { getDeviceType,formatDate } from '@/assets/js/common.js'
export default {
    components: { 
        mediaVideo,
        roomList,
        changeRoom,
        navbarVertical,
        navbar,
        notice,
        changeAmount
    },
    directives: {
        'set-size': {
            mounted(elem,binding){
                let _this=binding.instance;
                //设置画布大小
                _this.$root.setCanvasSize(elem);
                //绘制画布表格
                _this.$root.drawCanvasTable(elem,binding.value,false);
            }
        },
        'move-x':{
            mounted(elem,binding){
                let clickFn=(e,fn)=>{
                    elem.classList.add("untransition");
                    let clickX=e.pageX||e.targetTouches[0].pageX;//按下的x坐标
                    let width=getComputedStyle(elem).width.replace('px','');//总宽度
                    let parentWidth=getComputedStyle(elem.parentNode).width.replace('px','');//获取一版宽度
                    let left=Number(getComputedStyle(elem).left.replace('px',''));//左边距
                    fn(clickX,width,parentWidth,left);
                }
                let moveFn=(e,clickX,width,parentWidth,left)=>{
                    let moveX=e.pageX||(e.targetTouches&&e.targetTouches[0].pageX);//移动到的x坐标
                    let moveDistance=moveX-clickX;//移动的距离
                    let newLeft=left+moveDistance;//新的左边距
                    if(newLeft>0){//左边距不能大于0
                        newLeft=0;
                    }else if(Math.abs(newLeft)>width-parentWidth){//左边距不能小于总宽度-一版的宽度
                        newLeft=-(width-parentWidth);
                    }
                    elem.style.left=newLeft+"px";//新左边距=旧左边距+移动的距离
                }
                elem.onmouseup=(e1)=>{
                    elem.classList.remove("untransition");
                }
                elem.onmousedown=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.onmousemove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
                elem.ontouchstart=(e1)=>{
                    clickFn(e1,(clickX,width,parentWidth,left)=>{
                        document.ontouchmove=(e2)=>{
                            moveFn(e2,clickX,width,parentWidth,left);
                        }
                    })
                }
            }
        }
    },
    props: {
        hasChatMsg:false,//是否有未读的客服消息
        isPageReady:false,//页面是否加载完毕
        isFullscreen:{
            type:Boolean,
            default:false
        },//当前是否全屏
    },
    data() {
        return {
            AMOUTN_ARR,
            IS_REBATE,
            COMMAND,
            PEARL_TYPE,//获取路单类型配置
            COLOR,//获取颜色配置
            GAME_ID,//获取游戏id列表配置
            REBATE_TYPE,//获取佣金方式配置
            GAME_MODEL,
            MARK_TYPE,//印记类型
            pearlCount:{z:0,x:0,h:0,zd:0,xd:0},//统计
            pearlCountList:[],//多台面统计
            pearlArr:[],//台面路单列表
            virtualPearlArr:[],//台面问路路单列表
            nextZHollowStyle:"",//下局预测Z空心样式
            nextZBevelStyle:"",//下局预测Z斜线样式
            nextZSolidStyle:"",//下局预测Z实心样式
            nextXHollowStyle:"",//下局预测X空心样式
            nextXBevelStyle:"",//下局预测X斜线样式
            nextXSolidStyle:"",//下局预测X实心样式
            odds:{z:"0",x:"0",h:"0",zd:"0",xd:"0"},//赔率
            limitred:{z:"0-0",x:"0-0",h:"0-0",zd:"0-0",xd:"0-0"},//限红
            pool:{z:0,x:0,zd:0,xd:0,h:0},//池
            coruscateArr:[],//闪烁位集合，存放将要闪烁的位置
            currRebate:REBATE_TYPE.rebate,//当前佣金模式
            amount:10,//选中额度
            defaultAmountList:[10,100,1000,50000,100000],//排序后的选中额度列表
            submited:{z:0,x:0,h:0,zd:0,xd:0},//当前模式已提交的额度列表
            submiting:{z:0,x:0,h:0,zd:0,xd:0},//当前模式将要提交的额度列表
            lastSubmit:{z:0,x:0,h:0,zd:0,xd:0},//上一次提交的额度列表
            lastSubmitList:[],//上一次提交的台面对应额度列表
            submitedCount:0,//全部模式已提交的总额
            canClear:false,//是否可以点击清除
            canCancel:false,//是否可以点击取消
            canConfirm:false,//是否可以点击确定
            canAgain:false,//是否可以点击重复
            pearlObj: {
                id:0,//台面id
                pearl:[]//路单数据
            },//要重绘路单的对象
            countList:[],//路单统计列表
            isMultiple:false,//是否显示多台
            isShowNextPrediction:false,//当前是否显示着问路
            resultAudioList:[
                {
                    url:require('@/assets/media/baccarat/win_draw.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_h.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_l.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_x.mp3')
                },
                {
                    url:require('@/assets/media/baccarat/win_z.mp3')
                }
            ],//开结果音效
            pokerArr:[],//当前台面牌组
            showPokerArr:[],//要显示的牌组
            currPokerXY:[0,0],//当前要翻转的扑克
            pearlLayerStyle:{
                width:0,
                height:0,
                left:0,
                top:0,
                display:'none'
            },//鼠标移上路单的遮罩层
            point:[0,0],//鼠标在路单上的坐标点
            videoList:[],//视频线路地址，当前支持最多两个
            isShowMoreAmount:false,//是否显示更多筹码
            isShowPoker:true,//鼠标移入画布是否显示牌
            isShowPokerCompare:true,//是否显示牌的大小比较
            isModuleReady:false,//页面内组件是否加载完成
            isShowPearlMoreLayer:false,//是否显示查看全部路单遮罩层
            pearlMoreType:null,//当前显示的全部路单数据的类型
            pearlModel:2,//路子模式（1:模式1 2:模式2）
            readyVideoIdArr:[],//已加载好的视频id
            showPokerTimer:null,//显示牌计时器
            currRuleType:1,//玩家当前显示的玩法（1:十二生肖 2:十八罗汉 3:二十四节气）
            activeRuleType:0,//玩家当前已激活的玩法
            isShowMark:false,//是否显示连中印记
            isShowRule:false,//是否显示规则说明
            markOdds:[],//印记玩法返利
            isShowGetMark:false,//是否显示得到印记动画
            //新版台参数
            isScale:false,//是否放大提交区和视频区
            isScaleAmount:{z:false,x:false,h:false,zd:false,xd:false},//是否放大码额
            betPearlList:[],//多台路单列表
            betPokerArr:[],//多台牌组列表
            roomListStartPage:0,//台面列表分页起始页码
            currHoverRoom:null,//当前鼠标上移台面
            showMoreAmountRoomIdArr:[],//要显示更多筹码的台id
            betRoomInfoList:[],//多台信息
        };
    },
    computed: {
        userInfo() {
            return this.$store.state.userInfo;
        },
        roomInfo() {
            return this.$store.state.roomInfo;
        },
        tabGame(){
            return this.$store.state.tabGame;
        },
        currVideoLine(){
			return this.$store.state.currVideoLine;
		},
        audioSwitch(){
            return this.$store.state.audioSwitch;
        },
        gameModel(){
            return this.$store.state.gameModel;
        },
        videoLineList(){
            return this.$store.state.videoLineList;
        },
        currAmountList(){
            return this.$store.state.currAmountList;
        },
        roomList(){
            return this.$store.state.roomList;
        },
        betRoomIdList(){
            return this.$store.state.betRoomIdList;
        },
        getBetRoomList(){
            let list=[];
            for (let i = 0; i < this.betRoomIdList.length; i++) {
                list.push(this.roomList.find(v=>v.id==this.betRoomIdList[i]));
            }
            return list;
        }
    },
    created() {
        this.currRuleType=this.userInfo.markType;
    },
    mounted() {
        layer.closeAll();
        this.init();
        this.setWsMessage();
        addEventListener("resize",this.setResize);
    },
    unmounted() {
        removeEventListener("resize",this.setResize);
        delete this.$root.wsMsgObj["bac"];
    },
    methods: {
        init(){
            
            //获取台面视频
            if(this.currVideoLine==""){
                useLayer({str:this.$t("video.noVideoLine")});
            }else{
                this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
            }
            if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌台需要获取牌
                this.$emit("ws-send",COMMAND.all_getcurrpoker,this.roomInfo.game, this.roomInfo.id, this.userInfo.id,this.userInfo.guid);
            }else if(this.roomInfo.pokermode==POKER_TYPE.normal){//普通台正常获取赔率，明牌台需要获取牌之后再获取赔率
                this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
            }
            //获取限红
            this.$emit("ws-send",COMMAND.bac_getlimitred,this.userInfo.id,this.userInfo.guid);
            //获取各位置已提交额度
            this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
            //获取台面路单
            this.$emit("ws-send",COMMAND.all_getroompearl, this.roomInfo.game,this.roomInfo.id,200,"table", this.userInfo.id, this.userInfo.guid);
            //获取台面扑克
            this.$emit("ws-send",COMMAND.bac_getroompoker, this.roomInfo.id,this.roomInfo.boot,200,this.userInfo.id, this.userInfo.guid);
            //获取玩法配置信息
            this.$emit("ws-send",COMMAND.all_getrule,RULE_TYPE.mark, this.userInfo.id,this.userInfo.guid);
        },
        /**
         * 设置websocket响应事件
         */
        setWsMessage(){
            this.$root.wsMsgObj["bac"]=(data)=>{
                switch (data.command) {
                    case COMMAND.all_getroompearl:
                        if(data.id==this.roomInfo.id&&!this.isMultiple){//获取的是当前台面的数据并且非多台模式
                            this.pearlArr=data.pearl;
                        }else if(this.isMultiple){//是多台并且为当前多台台面数据
                            //先移除路单有，台列表没有的路单数据
                            let removeIndex=this.betPearlList.findIndex(v=>!this.betRoomIdList.find(b=>b==v.id));//找到有路单数据但没有台数据的路单下标
                            // let pearlIndex=this.betPearlList.findIndex(v=>v.id==data.id);
                            removeIndex!=-1&&this.betPearlList.splice(removeIndex,1);//旧数据有接收到数据的台数据则先移除
                            this.betPearlList.push({id:data.id,pearl:data.pearl});
                        }else if(this.currHoverRoom){//当前有鼠标上移的台
                            this.drawPearl(JSON.parse(JSON.stringify(data.pearl)),"bigPearl_"+data.id);
                        }
                        break;
                    case COMMAND.all_getvideo:
                        let videoArr=data.video;
                        let list=[];//拼装好的视频地址数组
                        for (let i = 0; i < videoArr.length; i++) {
                            list.push(data.flvline+'/'+videoArr[i]+'.flv');
                        }
                        let videoInfo=this.videoList.find(v=>v.id==data.id);
                        if(videoInfo){
                            videoInfo.videoArr=list;
                        }else{
                            this.videoList.push({
                                id:data.id,
                                videoArr:list
                            })
                        }
                        break;
                    case COMMAND.bac_getodds:
                        if(this.roomInfo.pokermode==POKER_TYPE.show){//明牌模式
                            this.odds={
                                z:0,
                                x:0,
                                h:0,
                                zd:0,
                                xd:0
                            }
                            if(this.showPokerArr.length>0&&this.showPokerArr[0][0]&&this.showPokerArr[1][0]){//前两张牌出了，才能算赔率
                                let zNum=this.$root.getPokerByNum(this.showPokerArr[0][0]).name;
                                let xNum=this.$root.getPokerByNum(this.showPokerArr[1][0]).name;
                                let str="z"+((zNum<=6||zNum=='A')?6: (zNum>6&&zNum<=9)?zNum:0 )+"x"+((xNum<=6||xNum=='A')?6: (xNum>6&&xNum<=9)?xNum:0 );//拼个字符串，好匹配key
                                let odd = data.odds.find(v=>v.key==str);
                                this.odds.z=odd.os[0];
                                this.odds.x=odd.os[1];
                                this.odds.h=odd.os[2];
                                this.odds.zd=odd.os[3];
                                this.odds.xd=odd.os[3];
                            }
                        }else if(this.roomInfo.pokermode==POKER_TYPE.normal){//正常模式
                            this.odds={
                                z:data.odds.z,
                                x:data.odds.x,
                                h:data.odds.h,
                                zd:data.odds.zd,
                                xd:data.odds.xd
                            }
                        }
                        break;
                    case COMMAND.bac_getlimitred:
                        this.limitred={
                            z:data.limitred.z,
                            x:data.limitred.x,
                            h:data.limitred.h,
                            zd:data.limitred.zd,
                            xd:data.limitred.xd
                        }
                        // this.autoAmount();
                        // //配置额度规则：永远保留10，最高小于两千保留20，最高小于一万保留50 最低在一千以下则保留100，
                        // let max=data.limitred.z.split('-')[1];
                        // if (max<=2000) {
                        //     this.currAmountListSort=[10,20,50,100,200,500,1000];
                        // }else if(max>2000&&max<=5000){
                        //     this.currAmountListSort=[10,50,100,200,500,1000,2000];
                        // }else if(max>5000&&max<=10000){
                        //     this.currAmountListSort=[10,100,200,500,1000,2000,5000];
                        // }else if(max>10000&&max<=20000){
                        //     this.currAmountListSort=[10,100,200,500,1000,5000,10000];
                        // }else if(max>20000&&max<=100000){
                        //     this.currAmountListSort=[10,100,500,1000,5000,10000,20000];
                        // }

                        //设置额度，优先取与限红一致的额度，个数超出则去除，不够则补足
                        // let limitredArr=Object.values(this.limitred).map(v=>v.split('-')).flat(Infinity);
                        // let noRepeatArr=[];//去掉重复项后的限红数组
                        // let chooseArr=[];//筛选出的额度数组
                        // for (let i = 0; i < limitredArr.length; i++) {//限红去重
                        //     noRepeatArr.indexOf(limitredArr[i])==-1&&noRepeatArr.push(limitredArr[i]);
                        // }
                        // for (let i = 0; i < AMOUTN_ARR.length; i++) {//挑选与限红一样的额度
                        //     noRepeatArr.indexOf(String(AMOUTN_ARR[i]))!=-1&&chooseArr.push(AMOUTN_ARR[i]);
                        // }
                        // if(chooseArr.length>7){//多于7个
                        //     this.currAmountListSort=chooseArr.slice(0,7);//取前5个
                        // }else if(chooseArr.length<7){//少于7个，等于7个不考虑
                        //     for (let i = 0; i < AMOUTN_ARR.length; i++) {//用额度列表中的额度补足
                        //         chooseArr.indexOf(AMOUTN_ARR[i])==-1&&chooseArr.push(AMOUTN_ARR[i]);
                        //         if(chooseArr.length==7){
                        //             break;
                        //         }
                        //     }
                        //     this.currAmountListSort=chooseArr;
                        // }
                        // this.currAmountListSort.sort((a,b)=>a-b);
                        break;
                    case COMMAND.all_endgame:
                        if(data.id==this.roomInfo.id&&!this.isMultiple){
                            this.resetAmount("submiting");
                        }else if(this.betRoomIdList.find(v=>v==data.id)&&this.isMultiple){
                            this.resetAmount("submiting",data.id);
                        }
                        break;
                    case COMMAND.bac_gameresult:
                        if(data.id==this.roomInfo.id&&!this.isMultiple){
                            this.currPokerXY=[0,0];
                            this.updatePearl(this.pearlArr,data.pearl);
                            this.setCoruscate(data.pearl,null,data.id);
                            this.isShowPokerCompare=true;
                            if(data.zpoker.length>0&&data.xpoker.length>0){//有牌
                                this.showPokerArr=[data.zpoker,data.xpoker];
                                this.pokerArr.push(this.showPokerArr);
                                setTimeout(() => {
                                    this.showPokerArr=[];
                                }, 5000);
                            }
                        }else if(this.betRoomIdList.find(v=>v==data.id)&&this.isMultiple){
                            this.updatePearl(this.pearlArr,data.pearl);
                            this.setCoruscate(data.pearl,null,data.id);
                        }
                        //切换台面/多台的台面列表中存在，则需要重新获取
                        typeof this.roomList.find(v=>v.id==data.id)!="undefined"&&this.$emit("ws-send",COMMAND.all_getroompearl,this.roomInfo.game,data.id,200,"list", this.userInfo.id, this.userInfo.guid);//台面存在且可见
                        break;
                    case COMMAND.all_getcurrpoker:
                        let len=data.poker.flat(Infinity).length;
                        if(data.id==this.roomInfo.id&&((!data.isget)||(data.isget&&len>0&&len<3))){//是当前台的数据并且是推送或者主动获取并且只有1~2张牌
                            this.isShowPoker=false;
                            this.isShowPokerCompare=false;
                            this.showPokerArr=data.poker;
                            this.currPokerXY=data.index;
                            
                        }
                        //由于明牌台赔率是根据牌动态改变的，所以需要在此获取
                        this.roomInfo.pokermode==POKER_TYPE.show&&this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
                        break;
                    case COMMAND.all_settlement:
                        if(data.id==this.roomInfo.id&&!this.isMultiple){
                            if(this.submitedCount>0){
                                this.$emit("ws-send",COMMAND.all_getgain,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);//有提交过才需要获取输赢
                                this.lastSubmit=JSON.parse(JSON.stringify(this.submited));//覆盖最后一次提交额
                                this.canAgain=false;
                            }
                            this.resetAmount("all");
                            this.submitedCount=0;
                            this.isShowPoker=true;
                        }else if(this.betRoomIdList.find(v=>v==data.id)&&this.isMultiple){
                            let info=this.betRoomInfoList.find(v=>v.id==data.id);
                            let room=this.roomList.find(v=>v.id==data.id);
                            if(info&&room){
                                if(info.submitedCount>0){
                                    this.$emit("ws-send",COMMAND.all_getgain,room.game,room.id,room.boot,room.innings,this.userInfo.id,this.userInfo.guid);//有提交过才需要获取输赢
                                    let lastSub = this.lastSubmitList.find(v=>v.id==data.id);
                                    if(lastSub){
                                        lastSub.submit=JSON.parse(JSON.stringify(info.submited));
                                    }else{
                                        this.lastSubmitList.push({
                                            id:data.id,
                                            submit:JSON.parse(JSON.stringify(info.submited))
                                        })
                                    }
                                }
                                this.resetAmount("all",data.id);
                                info.submitedCount=0;
                            }
                        }
                        break;
                    case COMMAND.all_getgain:
                        if(data.win!=0||data.lose!=0){
                            useLayer({str:(data.win > Math.abs(data.lose)? this.$t("common.win"):this.$t("common.lose"))+Math.abs(data.win - data.lose)});
                            if(data.win-data.lose>0&&!this.isShowMark){//赢了并且没点开印记界面则显示获得印记效果
                                this.isShowGetMark=true;
                                setTimeout(() => {
                                    this.isShowGetMark=false;
                                }, 2000);
                            }
                        }
                        break;
                    case COMMAND.bac_receivepool:
                        data.id==this.roomInfo.id&&(this.pool=data.pool);
                        break;
                    case COMMAND.bac_submitbet:
                        switch (data.result) {
                            case SUBMIT_RESULT.success:
                                useLayer({str:this.$t("common.subSuccess")});
                                this.$store.commit({
                                    type:MUTATION_TYPE.setUserInfo,
                                    userInfo:{
                                        realCoin:data.realmoney
                                    }
                                })
                                if(this.isMultiple){
                                    let info=this.betRoomInfoList.find(v=>v.id==data.id);
                                    if(info){
                                        for (let i in info.submited) {//将本次提交的额度追加到已提交的额度中
                                            info.submited[i]+=info.submiting[i];
                                            info.submitedCount+=info.submiting[i];
                                        }
                                        this.resetAmount("submiting",data.id);//清空将提交额度列表
                                    }
                                }else{
                                    for (let i in this.submited) {//将本次提交的额度追加到已提交的额度中
                                        this.submited[i]+=this.submiting[i];
                                        this.submitedCount+=this.submiting[i];
                                    }
                                    this.resetAmount("submiting");//清空将提交额度列表
                                }
                                break;
                            case SUBMIT_RESULT.ban:
                                useLayer({str:this.$t("common.subBan")});
                                break;
                            case SUBMIT_RESULT.unmoney:
                                useLayer({str:this.$t("common.unMoney")});
                                break;
                            case SUBMIT_RESULT.countdown:
                                useLayer({str:this.$t("common.subCountdown")});
                                break;
                            case SUBMIT_RESULT.outside:
                                useLayer({str:this.$t("common.unLimit")});
                                break;
                            case SUBMIT_RESULT.service:
                                useLayer({str:this.$t("common.service")});
                                break;
                            case SUBMIT_RESULT.malice:
                                useLayer({str:""});
                                break;
                            default:
                                useLayer({str:this.$t("common.subErr")});
                                break;
                        }
                        break;
                    case COMMAND.all_cancelbet:
                        if(data.result==CANCEL_RESULT.success){
                            this.resetAmount("all");
                            this.submitedCount=0;
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    realCoin:data.realmoney
                                }
                            })
                            useLayer({str:this.$t("common.cancelSuccess")});
                        }else{
                            useLayer({str:this.$t("common.cancelErr")});
                        }
                        break;
                    case COMMAND.all_changeboot:
                        if(data.id==this.roomInfo.id){
                            this.pearlArr=[];
                            this.pokerArr=[];
                            this.$store.commit({
                                type:MUTATION_TYPE.setRoomInfo,
                                roomInfo:{
                                    boot:data.boot,
                                    innings:data.innings
                                }
                            })
                        }
                        break;
                    case COMMAND.bac_getbetdetail:
                        if(this.isMultiple){
                            let info=this.betRoomInfoList.find(v=>v.id==data.id);
                            if(info){
                                info.submited={
                                    z:Number(data.detail[info.currRebate].z),
                                    x:Number(data.detail[info.currRebate].x),
                                    h:Number(data.detail[info.currRebate].h),
                                    zd:Number(data.detail[info.currRebate].zd),
                                    xd:Number(data.detail[info.currRebate].xd)
                                }
                                info.submitedCount= Object.values(data.detail[0]).concat(Object.values(data.detail[1])).reduce((prev,val)=>prev+val);
                            }
                        }else{
                            this.submited={
                                z:Number(data.detail[this.currRebate].z),
                                x:Number(data.detail[this.currRebate].x),
                                h:Number(data.detail[this.currRebate].h),
                                zd:Number(data.detail[this.currRebate].zd),
                                xd:Number(data.detail[this.currRebate].xd)
                            }
                            this.submitedCount= Object.values(data.detail[0]).concat(Object.values(data.detail[1])).reduce((prev,val)=>prev+val);
                        }
                        break;
                    case COMMAND.all_entertable:
                        if(data.result==RESULT.enterTable.success){
                            let roomItem=this.roomList.find(v=>v.id==data.id);
                            this.showPokerArr=[];
                            if(roomItem.game==GAME_ID.bac||roomItem.game==GAME_ID.lh){//与当前游戏一致则只修改参数
                                this.$root.$refs.startAudioPlayer.pause();
                                this.$root.$refs.endAudioPlayer.pause();
                                this.$root.$refs.tenAudioPlayer.pause();
                                // this.$refs.resultAudioPlayer.pause();
                                //更改台面信息
                                this.$store.commit({
                                    type:MUTATION_TYPE.setRoomInfo,
                                    roomInfo:roomItem
                                })
                                this.pokerArr=[];
                                this.isShowPearlMoreLayer=false;
                                this.pearlMoreType=null;
                                data.iscommission==IS_REBATE.false&&(this.currRebate=REBATE_TYPE.rebate);//不能免佣则重置佣金模式为非免佣
                                this.init();
                                // //获取台面路单
                                // this.$emit('ws-send', COMMAND.all_getroompearl, roomItem.game,data.id,200,"table", this.userInfo.id, this.userInfo.guid);
                                // //获取台面视频
                                // if(this.currVideoLine==""){
                                //     useLayer({str:this.$t("video.noVideoLine")});
                                // }else{
                                //     this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,this.currVideoLine,this.userInfo.id,this.userInfo.guid);
                                // }
                                // //获取限红
                                // this.$emit("ws-send",COMMAND.bac_getlimitred,this.userInfo.id,this.userInfo.guid);
                                // //获取各位置已提交额度
                                // this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                                // //获取赔率
                                // this.$emit("ws-send",COMMAND.bac_getodds,this.roomInfo.id,this.userInfo.id,this.userInfo.guid);
                                // //获取台面扑克
                                // this.$emit("ws-send",COMMAND.bac_getroompoker, this.roomInfo.id,this.roomInfo.boot,200,this.userInfo.id, this.userInfo.guid);
                            
                            }else{//不一致则进行页面跳转
                                this.$store.commit({
                                    type:MUTATION_TYPE.setRoomInfo,
                                    roomInfo:roomItem
                                })
                                this.$root.goPage(GAME_CODE[roomItem.game]);
                            }
                        }
                        break;
                    case COMMAND.bac_getroompoker:
                        let arr=data.list;
                        if(this.isMultiple){
                            // for (let i = 0; i < arr.length; i++) {
                            //     this.betPokerArr.push({id:} [arr[i].zp,arr[i].xp]);
                            // }
                        }else{
                            for (let i = 0; i < arr.length; i++) {
                                // arr[i].zp.length>0&&arr[i].xp.length>0&&
                                this.pokerArr.push([arr[i].zp,arr[i].xp]);
                            }
                        }
                        break;
                    case COMMAND.all_refresh:
                        data.id==this.roomInfo.id&&this.$emit("ws-send",COMMAND.all_getroompearl, data.game,data.id,200,"table", this.userInfo.id, this.userInfo.guid);
                        break;
                    case COMMAND.all_setruletype:
                        if(data.result==1){//成功
                            let mark=0;//默认重置进度
                            if(data.type>this.userInfo.markType){//升级需要继承进度
                                mark=this.userInfo.mark;
                            }
                            this.$store.commit({
                                type:MUTATION_TYPE.setUserInfo,
                                userInfo:{
                                    markType:data.type==0?this.userInfo.markType:data.type,
                                    mark:mark
                                }
                            })
                            this.activeRuleType=this.currRuleType;
                        }else{
                            useLayer({str:"激活失败！"});
                        }
                        break;
                    case COMMAND.all_getrule:
                        this.markOdds=[data.z12,data.z18,data.z24];
                        break;
                }
            }
        },
        /**
         * 绘制顺序路
         * @param {Object} elemObj 使用drawCanvasTable绘制画布表格返回的对象
         * @param {Array} pearlArr 路单数据
         * @param {PEARL_TYPE} type 路单类型
         */
        drawOrderPearl(elemObj,pearlArr,type){
            let arr=JSON.parse(JSON.stringify(pearlArr));//深克隆一份数组防止操作到原数组
            let ctx = elemObj.elem.getContext('2d');
            let radius=2.6;//半径比例
            let cellHeight = elemObj.cellHeight;
            let cellWidth = elemObj.cellWidth;
            let xCode=PEARL_CODE.X;
            let zCode=PEARL_CODE.Z;
            ctx.lineWidth = cellWidth * .12;//边框粗细
            ctx.textBaseline = 'middle';
            if(type==PEARL_TYPE.big_three){
                arr=arr.flat(Infinity).filter((val)=>{
                    return PEARL_CODE.H.indexOf(val.substring(0,1))==-1;//转一维数组后去掉和
                })
                arr=arr.slice(-(elemObj.column - 1) * 3 - arr.length % 3);//取倒数的数据
                for (var i = 0; i < arr.length; i++) {
                    //设置圆圈颜色
                    var letter = arr[i].substr(0, 1);//获取首字母
                    if (xCode.indexOf(letter)!=-1) {
                        ctx.fillStyle = COLOR.blue;//填充颜色
                        ctx.strokeStyle = COLOR.blue;
                    } else if (zCode.indexOf(letter)!=-1) {
                        ctx.fillStyle = COLOR.red;
                        ctx.strokeStyle = COLOR.red
                    }
                    ctx.beginPath();
                    ctx.arc((Math.ceil((i + 1) / 3) - 1) * cellWidth + cellWidth / 2, (i % 3) * cellHeight + cellHeight / 2, cellWidth / radius, 0, 2 * Math.PI);
                    ctx.stroke();
                }
            }else if(type==PEARL_TYPE.big_text){
                var text = '';//填充文本
                var countArr = [0, 0, 0, 0, 0];//庄，闲，和，庄对，闲对 的统计
                radius=2.3;
                ctx.font = 'bold '+cellWidth * .5 + 'px SimHei';
                arr=arr.flat(Infinity);
                arr=arr.slice(-(elemObj.column - 1) * 6 - arr.length % 6);//转一维数组后取倒数的数据
                for (let i = 0; i < arr.length; i++) {
                    // 创建渐变
                    let grd=ctx.createRadialGradient(
                        (Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2,
                        (i % 6) * cellHeight + cellHeight / 2,
                        cellWidth / radius,
                        (Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2-(cellWidth / radius/2),//x坐标减去二分之一半径
                        (i % 6) * cellHeight + cellHeight / 2-(cellWidth / radius/2),
                        0);
                    //填充圆圈
                    var letter = arr[i].substr(0, 1);//获取首字母
                    let color;
                    let isSix=this.gameModel==GAME_MODEL.tel?arr[i].substr(-1)=="0":false;//是否是幸运6(电话模式有效)
                    ctx.font =isSix?('bold '+cellWidth * .4 + 'px SimHei'):('bold '+cellWidth * .5 + 'px SimHei');
                    if (PEARL_CODE.X.indexOf(letter)!=-1) {
                        color = COLOR.blue;//填充颜色
                        text = letter == 'N' ? this.$t("common.hu") : this.$t("common.x");
                    } else if (PEARL_CODE.Z.indexOf(letter)!=-1) {
                        // color = isSix?"#ff1e88":COLOR.red;
                        color = COLOR.red;
                        text = letter == 'M' ? this.$t("common.l") : (isSix?(this.$t("common.z")+"6"):this.$t("common.z"));
                    } else if (PEARL_CODE.H.indexOf(letter)!=-1) {
                        color = COLOR.green;
                        text = this.$t("common.h");
                    }
                    grd.addColorStop(0,color);
                    grd.addColorStop(1,COLOR.ray);
                    // grd.addColorStop(1,"#ccc");
                    ctx.fillStyle = grd;
                    ctx.beginPath();
                    ctx.arc((Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2, (i % 6) * cellHeight + cellHeight / 2, cellWidth / radius, 0, 2 * Math.PI);
                    ctx.fill();
                    //填充字
                    ctx.fillStyle="#fff";
                    ctx.fillText(text, (Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2 - ctx.measureText(text).width / 2, (i % 6) * cellHeight + cellHeight / 2);
                    //填充圆点
                    if (PEARL_CODE.ZD.indexOf(letter)!=-1) {//含有庄对
                        ctx.fillStyle = COLOR.red;
                        ctx.beginPath();
                        ctx.arc((Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2 - cellWidth / 3.5, (i % 6) * cellHeight + cellHeight / 2 - cellHeight / 3.5, cellWidth / radius / 3.5, 0, 2 * Math.PI);
                        ctx.fill();
                    }
                    if (PEARL_CODE.XD.indexOf(letter)!=-1) {//含有闲对
                        ctx.fillStyle = COLOR.blue;
                        ctx.beginPath();
                        ctx.arc((Math.ceil((i + 1) / 6) - 1) * cellWidth + cellWidth / 2 + cellWidth / 3.5, (i % 6) * cellHeight + cellHeight / 2 - cellHeight / 3.5, cellWidth / radius / 3.5, 0, 2 * Math.PI);
                        ctx.fill();
                    }
                    //数量统计
                    switch (letter) {
                        case 'D':
                            countArr[0]++; countArr[3]++; break;
                        case 'H':
                            countArr[1]++; countArr[4]++; break;
                        case 'L':
                            countArr[2]++; countArr[3]++; countArr[4]++; break;
                        case 'G':
                            countArr[1]++; countArr[3]++; break;
                        case 'I':
                            countArr[1]++; countArr[3]++; countArr[4]++; break;
                        case 'F':
                            countArr[0]++; countArr[3]++; countArr[4]++; break;
                        case 'J':
                            countArr[2]++; countArr[3]++; break;
                        case 'K':
                            countArr[2]++; countArr[4]++; break;
                        case 'E':
                            countArr[0]++; countArr[4]++; break;
                        case 'O':
                        case 'C':
                            countArr[2]++; break;
                        case 'A':
                        case 'M':
                            countArr[0]++; break;
                        case 'B':
                        case 'N':
                            countArr[1]++; break;
                    }
                }
                return {
                    z:countArr[0],
                    x:countArr[1],
                    h:countArr[2],
                    zd:countArr[3],
                    xd:countArr[4],
                }
                this.pearlCount.z=countArr[0];
                this.pearlCount.x=countArr[1];
                this.pearlCount.h=countArr[2];
                this.pearlCount.zd=countArr[3];
                this.pearlCount.xd=countArr[4];
                console.log(JSON.stringify(this.pearlCount))
            }
        },
        /**
         * 将数据转换成小路需要的数据
         * @param {Array} pearlArr 路单数据
         * @param {PEARL_TYPE} type 小路的类型
         */
        convertToSmallPearl(pearlArr,type){
            let str="";//根据当前判断条件要生成的路单代号
            let arr=[];
            for (let i = 1 + type; i < pearlArr.length; i++){
                for (let j = 0; j < pearlArr[i].length; j++){
                    if ((i > 1 + type) && j == 0) {//从第3列开始，仅比较一次前两列个数
                        if (pearlArr[i - 1].length == pearlArr[i - (2 + type)].length) {//相同(红)
                            str='A';
                        } else {//不同(蓝)
                            str='B';
                        }
                    } else if ((i > 0 + type) && j > 0 && pearlArr[i][j]) {//从第2列第2行开始，如果有值，则对应上一列同行，
                        if (pearlArr[i - (1 + type)][j]) {//有同行(红)
                            str='A';
                        } else {//无同行(蓝，且本列本行到本列结束皆为红)
                            if (j > 1 && !pearlArr[i - (1 + type)][j - 1]) {//有上一行并且上一行无对应的上一列同行
                                str='A';
                            } else {
                                str='B';
                            }
                        }
                    } else {
                        continue;
                    }
                    if(arr.length>0&&arr[arr.length-1].indexOf(str)!=-1){
                        arr[arr.length-1].push(str);
                    }else{
                        arr.push([str]);
                    }
                }
            }
            return arr;
        },
        /**
         * 设置窗口大小改变
         */
        setResize(){
            this.drawPearl(this.pearlArr);
            this.drawMorePearl(this.pearlMoreType);
        },
        /**
         * 设置闪烁位
         */
        setCoruscate(pearl,fn,id){
            let arr=[];
            pearl=pearl.substr(0,1);
            if(PEARL_CODE.Z.indexOf(pearl) != -1){
                arr.push('z');
                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?4:2);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.X.indexOf(pearl) != -1){
                arr.push('x');
                this.$refs.resultAudioPlayer.currentPlayIndex=(this.roomInfo.game==GAME_ID.bac?3:1);
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }else if(PEARL_CODE.H.indexOf(pearl) != -1){
                arr.push('h');
                this.$refs.resultAudioPlayer.currentPlayIndex=0;
                this.$nextTick(()=>{
                    this.$refs.resultAudioPlayer.play();
                })
            }
            PEARL_CODE.ZD.indexOf(pearl) != -1 && arr.push('zd');
            PEARL_CODE.XD.indexOf(pearl) != -1 && arr.push('xd');
            let coruscate=this.coruscateArr.find(v=>v.id==id);
            if(coruscate){
                coruscate.coruscate=arr;
            }else{
                coruscate={
                    id,
                    coruscate:arr
                };
                this.coruscateArr.push(coruscate);
            }
            setTimeout(() => {
                coruscate.coruscate=[];
                fn&&fn();
            }, 3000);
        },
        /**
         * 设置当前佣金模式
         */
        setRebate(e){

            if(this.roomInfo.iscommission==IS_REBATE.false){//不能免佣
                useLayer({str:this.$t("video.noChangeRebate")});
                e.target.checked=false;
            }else{//可以免佣
                let fn=()=>{
                    if(this.currRebate==REBATE_TYPE.rebate){
                        this.currRebate=REBATE_TYPE.noRebate;
                    }else if(this.currRebate==REBATE_TYPE.noRebate){
                        this.currRebate=REBATE_TYPE.rebate;
                    }
                    this.resetAmount("submiting");
                    //获取各位置已提交额度
                    this.$emit("ws-send",COMMAND.bac_getbetdetail,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                }
                if(this.getAmountCount("submiting")!=0){//有未提交的额度
                    e.target.checked=!e.target.checked;
                    useLayer({
                        type:LAYER_TYPE.confirm,
                        str:this.$t("video.noChangeRebate"),
                        btn:[this.$t("common.yes"),this.$t("common.no")],
                        yesFn:(i)=>{
                            fn();
                            layer.close(i);
                        }
                    });
                }else{//没有未提交的项
                    fn();
                }
            }
        },
        /**
         * 提交事件
         */
        submitEvent(event,id){
            switch (event) {
                case "clear"://点击清除
                    if(this.isMultiple){
                        this.getAmountCount("submiting",id)!=0&&this.resetAmount("submiting",id);
                    }else{
                        this.getAmountCount("submiting",id)!=0&&this.resetAmount("submiting",id);
                    }
                    break;
                case "cancel"://点击取消
                    if(this.canCancel){
                        useLayer({
                            type:LAYER_TYPE.confirm,
                            str:this.$t("common.isCancel"),
                            btn:[this.$t("common.yes"),this.$t("common.no")],
                            yesFn:(i)=>{
                                layer.close(i);
                                this.$emit("ws-send",COMMAND.all_cancelbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,this.userInfo.id,this.userInfo.guid);
                            }
                        })
                    }
                    break;
                case "confirm"://点击确定
                    if(this.isMultiple){
                        let room=this.getBetRoomList.find(v=>v.id==id);
                        let info=this.betRoomInfoList.find(v=>v.id==id);
                        if(room){
                            this.$emit("ws-send",COMMAND.bac_submitbet,room.game,room.id,room.boot,room.innings,
                                    this.getAmountCount("submiting",id),this.getAmountCount("submiting",id)+info.submitedCount,info.currRebate,
                                    String(info.submiting.z)+","+String(info.submiting.x)+","+String(info.submiting.h)+","+String(info.submiting.zd)+","+String(info.submiting.xd)+",0,0,0,0",
                                    this.userInfo.id,this.$root.ip.cip,getDeviceType(),this.userInfo.guid);
                        }
                    }else{
                        if(this.canConfirm){
                            this.$emit("ws-send",COMMAND.bac_submitbet,this.roomInfo.game,this.roomInfo.id,this.roomInfo.boot,this.roomInfo.innings,
                                this.getAmountCount("submiting"),this.getAmountCount("submiting")+this.submitedCount,this.currRebate,
                                String(this.submiting.z)+","+String(this.submiting.x)+","+String(this.submiting.h)+","+String(this.submiting.zd)+","+String(this.submiting.xd)+",0,0,0,0",
                                this.userInfo.id,this.$root.ip.cip,getDeviceType(),this.userInfo.guid);
                        }
                    }
                    break;
                case "again"://点击重复
                    if(this.isMultiple){
                        let last = this.lastSubmitList.find(v=>v.id==id);
                        if(last){
                            let info = this.betRoomInfoList.find(v=>v.id==id);
                            info.submiting=JSON.parse(JSON.stringify(last.submit));
                            this.$nextTick(()=>{
                                this.submitEvent('confirm',id);
                            })
                        }
                    }else{
                        if(this.canAgain){
                            this.submiting=JSON.parse(JSON.stringify(this.lastSubmit));
                            this.$nextTick(()=>{
                                this.submitEvent('confirm');
                            })
                        }
                    }
                    break;
                case "multiple"://点击多台
                    //保存多台列表
                    if(this.betRoomIdList.length<=0){
                        this.$store.commit({
                            type:MUTATION_TYPE.setBetRoomIdList,
                            betRoomIdList:this.roomList.slice(0,3).map(v=>v.id)
                        })
                    }
                    this.isMultiple=!this.isMultiple;//变换模式
                    break;
            }
        },
        /**
         * 为位置追加将要提交的额度
         * @param {String} type 位置类型(z、x、h、zd、xd)
         */
        addAmount(type,event,id){
            let limitred=this.limitred[type].split('-');//获取限红
            let amount=this.amount;
            if(this.isMultiple){
                let info=this.betRoomInfoList.find(v=>v.id==id);
                let room=this.getBetRoomList.find(v=>v.id==id);
                if(info&&room){
                    if(room.countdown<=0){
                        useLayer({str:this.$t("room.noStartGame")});
                        return;
                    }
                    // else if(this.userInfo.realCoin<this.getAmountCount("submiting")+amount){//余额不足
                    //     useLayer({str:this.$t("common.unMoney")});
                    //     return;
                    // }

                }
                info.submiting[type]=info.submiting[type]+(info.amount||0);
            }else{
                if(!this.odds[type]){
                    useLayer({str:"该位置赔率为0，暂无法在该位置下注！"});
                    return;
                }
                if(this.roomInfo.countdown<=0){
                    useLayer({str:this.$t("room.noStartGame")});
                    return;
                }else if(this.userInfo.realCoin<this.getAmountCount("submiting")+amount){//余额不足
                    useLayer({str:this.$t("common.unMoney")});
                    return;
                }
                if(amount!=-1){//非满额度
                    if(amount>limitred[1]){//单次高于上限
                        useLayer({str:this.$t("room.higherLimitred")+limitred[1]});
                        return;
                    }else if(this.submiting[type]+this.submited[type]+amount>limitred[1]){//多次并高于上限
                        useLayer({str:this.$t("room.laveLimitred")+(limitred[1]-this.submiting[type]-this.submited[type])});
                        return;
                    }
                }else{//满额度
                    amount=limitred[1]-this.submiting[type]-this.submited[type];
                    if(amount==0){
                        useLayer({str:this.$t("room.fullAmount")});
                        return;
                    }
                }
                this.submiting[type]=this.submiting[type]+amount;
            }
            // if(event){
            //     this.isScaleAmount[type]=true;
            //     setTimeout(() => {
            //         this.isScaleAmount[type]=false;
            //     }, 120);
            // }
        },
        /**
         * 获取额度
         * @param {String} type 额度类型(submited、submiting、all)
         */
        getAmountCount(type,id){
            let count=0;
            if(type=="submiting"||type=="all"){//预投或总投
                if(this.isMultiple){
                    let info=this.betRoomInfoList.find(v=>v.id==id);
                    for (let i in info.submiting) {
                        count+=info.submiting[i];
                    }
                }else{
                    for (let i in this.submiting) {
                        count+=this.submiting[i];
                    }
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(this.isMultiple){
                    let info=this.betRoomInfoList.find(v=>v.id==id);
                    for (let i in info.submited) {
                        count+=info.submited[i];
                    }
                }else{
                    for (let i in this.submited) {
                        count+=this.submited[i];
                    }
                }
            }
            if(type=="lastSubmit"){
                for (let i in this.lastSubmit) {
                    count+=this.lastSubmit[i];
                }
            }
            return count;
        },
        /**
         * 重置额度
         */
        resetAmount(type,id){
            if(type=="submiting"||type=="all"){//预投或总投
                if(this.isMultiple){
                    let info=this.betRoomInfoList.find(v=>v.id==id);
                    for (let i in info.submiting) {
                        info.submiting[i]=0;
                    }
                }else{
                    for (let i in this.submiting) {
                        this.submiting[i]=0;
                    }
                }
            }
            if(type=="submited"||type=="all"){//已投或总投
                if(this.isMultiple){
                    let info=this.betRoomInfoList.find(v=>v.id==id);
                    for (let i in info.submited) {
                        info.submited[i]=0;
                    }
                }else{
                    for (let i in this.submited) {
                        this.submited[i]=0;
                    }
                }
            }
        },
        /**
         * 问路
         */
        nextPrediction(pearl){
            if(!this.isShowNextPrediction){//当前没有在显示问路，防止多次点击
                this.isShowNextPrediction=true;
                let virtualArr=JSON.parse(JSON.stringify(this.pearlArr));//深克隆一个虚拟数组
                this.updatePearl(virtualArr,pearl);
                this.drawPearl(virtualArr);
                this.nextPredictionTimer = setTimeout(() => {
                    this.drawPearl(this.pearlArr);
                    this.isShowNextPrediction=false;
                }, 1000);
            }
        },
        /**
		 * 更新路单信息
		 * @param {Array} pearlArr 路单列表
		 * @param {String} pearl 路单数据
		 */
		updatePearl(pearlArr,pearl){
			if (pearlArr && pearlArr.length > 0 && (
				(PEARL_CODE.Z.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.Z.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.X.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.X.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1) ||
				(PEARL_CODE.H.indexOf(pearl.substr(0, 1)) != -1 && PEARL_CODE.H.indexOf(pearlArr[pearlArr.length - 1][0].substr(0, 1)) != -1)
				)) {//如果当前的露珠类型与上一项同类，则加到上一项的队列中
				pearlArr[pearlArr.length - 1].push(pearl);
			} else {//否则新建自己的队列
				pearlArr.push([pearl]);
			}
		},
        /**
         * 绘制路单
         */
        drawPearl(pearlArr,elemId){
            let countObj;
            // if(!this.isMultiple){//非多台
                //画表格
                let elemList;
                if(this.isMultiple||elemId){
                    elemList=document.querySelectorAll('#'+elemId);
                }else{
                    elemList=document.querySelectorAll("[data-canvas-room]");
                }
                for (let elem of elemList){
                    let val=elem.dataset.canvasRoom;//获取data-canvas-room属性的值
                    //设置画布大小
                    this.$root.setCanvasSize(elem);
                    //绘制画布表格
                    let obj = this.$root.drawCanvasTable(elem,val,false);
                    if(obj){//判断对象是否存在，防止视口被拉小到没有的时候找不到而报错
                        if(obj.elem.id=='textBigPearl'||obj.elem.id==elemId){
                            //设置移入带字大路区的遮罩层大小
                            this.pearlLayerStyle.width=obj.cellWidth/RATIO+'px';
                            this.pearlLayerStyle.height=obj.cellHeight/RATIO+'px';
                        }
                        //画路单
                        if(pearlArr.length>0){
                            var delTieArr=this.$root.setPearlData(this.roomInfo.game,pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                            if(obj.elem.id=="textBigPearl"||(obj.elem.id==elemId&&elemId.indexOf('textBigPearl')!=-1)){
                                countObj= this.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_text);
                            }else if(obj.elem.id=="threePearl"){
                                this.drawOrderPearl(obj,pearlArr,PEARL_TYPE.big_three);
                            }else if(obj.elem.id=="bigPearl"||(obj.elem.id==elemId&&elemId.indexOf('bigPearl')!=-1)){
                                
                                this.$root.drawPearl(obj,this.$root.setPearlData(this.roomInfo.game,pearlArr,obj.column-1,false),PEARL_TYPE.big_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallHollowPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.convertToSmallPearl(delTieArr,PEARL_TYPE.small_hollow),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_hollow,GAME_ID.bac);
                            }else if(obj.elem.id=="smallSolidPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.convertToSmallPearl(delTieArr,PEARL_TYPE.small_solid),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.small_solid,GAME_ID.bac);
                            }else if(obj.elem.id=="bevelPearl"){
                                this.$root.drawPearl(obj,
                                    this.$root.setPearlData(this.roomInfo.game,this.convertToSmallPearl(delTieArr,PEARL_TYPE.bevel),obj.column*2-1,false),//第二次调用setPearlData是为了保留多少列
                                    PEARL_TYPE.bevel,GAME_ID.bac);
                            }
                        }
                    }
                }
                //更新下局预测
                if(pearlArr.length>0){
                    if(delTieArr&&delTieArr.length>0){//判断去掉和之后的数组长度大于0，防止第一口为和时报错
                        let lastLetter=delTieArr[delTieArr.length-1][0].substring(0,1);//获取最后一列的第一项的首字母
                        let str;
                        if(PEARL_CODE.Z.indexOf(lastLetter)!=-1){//判断最后一列是Z类
                            //下局z
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            //下局x
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['B']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['B']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['B']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                        }else if(PEARL_CODE.X.indexOf(lastLetter)!=-1){//X类
                            //下局z
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-2).concat([['A']]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextZHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-3).concat([['A']]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1))
                            this.nextZBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-4).concat([['A']]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextZSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            //下局x
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-2,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_hollow
                                    ).flat().slice(-1));
                            this.nextXHollowStyle="color:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');//取倒数第二列拼上追加了虚拟项的倒数第一列
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-3,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.bevel
                                    ).flat().slice(-1));
                            this.nextXBevelStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                            str=String(this.convertToSmallPearl(
                                        delTieArr.slice(-4,-1).concat([delTieArr.slice(-1).flat().concat(lastLetter)]),
                                        PEARL_TYPE.small_solid
                                    ).flat().slice(-1));
                            this.nextXSolidStyle="background:"+(str?(str=='A'?COLOR.red:COLOR.blue):'inherit');
                        }
                    }
                }else{
                    if(!this.isMultiple&&!elemId){
                        this.pearlCount={z:0,x:0,h:0,zd:0,xd:0};//清空统计
                        this.nextZHollowStyle="";
                        this.nextZBevelStyle="";
                        this.nextZSolidStyle="";
                        this.nextXHollowStyle="";
                        this.nextXBevelStyle="";
                        this.nextXSolidStyle="";
                    }
                }
                return countObj;
            // }
        },
        /**
         * 显示牌
         * @param {Number} type 移入或移出
         */
        showPoker(e,type){
            if(type==1){//移入
                if(this.isShowPoker){
                    console.log(JSON.stringify(this.pokerArr));
                    let cellWidth=this.pearlLayerStyle.width.replace('px','');
                    let cellHeight=this.pearlLayerStyle.height.replace('px','');
                    let column=(getComputedStyle(e.target).width.replace('px','')/cellWidth).toFixed();//获取总列数
                    let x = Math.ceil(e.offsetX / cellWidth);//列
                    let y = Math.ceil(e.offsetY / cellHeight);//行
                    let array=this.pearlArr.flat(Infinity);
                    let pokerArr=this.pokerArr.slice(-(column - 1) * 6 - array.length % 6);//取倒数的数据
                    let poker=pokerArr[(x-1)*6+(y-1)];//获取对应位置的扑克
                    if((x!=this.point[0]||y!=this.point[1])&&x!=0&&y!=0&&poker&&poker.flat(Infinity).length>0){//坐标点相比于上次有不同并且大于0行0列并且对应位置有扑克数据
                        console.log(JSON.stringify(poker))
                        this.point=[x,y];
                        this.$nextTick(()=>{
                            this.pearlLayerStyle.display='block';
                            this.pearlLayerStyle.left=(x-1)*cellWidth+'px';
                            this.pearlLayerStyle.top=(y-1)*cellHeight+'px';
                            this.showPokerArr=poker;
                            this.showPokerTimer&&clearTimeout(this.showPokerTimer);
                            this.showPokerTimer = setTimeout(() => {
                                this.showPokerArr=[];
                            }, 5000);
                        })
                    }else{
                        this.showPokerArr=[];
                        this.pearlLayerStyle.display='none';
                        this.point=[0,0];
                    }
                }
            }else{//移出
                this.showPokerArr=[];
                this.pearlLayerStyle.display='none';
                this.point=[0,0];
                this.showPokerTimer&&clearTimeout(this.showPokerTimer);
            }
        },
        /**
         * 根据牌获取点数
         */
        getPoint(pokerArr){
            if(this.roomInfo.game==GAME_ID.bac){
                return pokerArr.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10||0;
            }else{
                return pokerArr.reduce((prev,val)=>prev+Math.ceil(val/4),0)||0;
            }
        },
        /**
         * 牌是否赢
         */
        isPokerWin(index){
            if(this.roomInfo.game==GAME_ID.bac){
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+(Math.ceil(val/4)>10?10:Math.ceil(val/4)),0)%10);
                return sumArr[index]>sumArr[1-index]?true:false;
            }else{
                let sumArr = this.showPokerArr.map(v=>v.reduce((prev,val)=>prev+Math.ceil(val/4),0));
                return sumArr[index]>sumArr[1-index]||(sumArr[index]==sumArr[1-index]&&this.showPokerArr[index]>this.showPokerArr[1-index])?true:false;//牌大或者牌一样并且花色大
            }
        },
        /**
         * 获取台面路单
         * @param {Number} tableId 台面id
         * @param {Number} column 获取的数据列数
         */
        getRoomPearl(gameId,tableId,column){
            this.$emit("ws-send",COMMAND.all_getroompearl, gameId,tableId,this.tabGame==GAME_ID.bac?200:column,"list", this.userInfo.id, this.userInfo.guid);
        },
        /**
         * 额度换算
         */
        chipsConvert(amount){
            let arr=[];//最终转换成的额度
            let amountArr = AMOUTN_ARR.slice(0,AMOUTN_ARR.length-1);//取除了梭哈之外的额度
            for (let i = amountArr.length-1; i >= 0; i--) {
                if(amount>=amountArr[i]){
                    let num=Math.floor(amount/amountArr[i]);//获取要换算的额度最多能换到多少个当前遍历到的额度
                    for (let j = 0; j < num; j++) {
                        arr.push(amountArr[i]);
                    }
                    amount-=num*amountArr[i];
                }
            }
            return arr;
        },
        /**
         * 显示全部路单
         * @param {PEARL_TYPE} pearlType 台面id
         */
        showMorePearl(pearlType){
            this.pearlMoreType=pearlType;
            this.$nextTick(()=>{
                this.drawMorePearl(pearlType);
                this.isShowPearlMoreLayer=false;
            })
        },
        /**
         * 绘制全部历史路单
         */
        drawMorePearl(pearlType){
            let obj;
            let elem=document.getElementById("fullPearl");//获取画布元素
            if(elem){
                let style=getComputedStyle(elem);//获取画布样式
                let height=style.height.replace('px','');//获取画布高度
                let width=getComputedStyle(elem.parentElement).width.replace('px','');//获取一版画布的宽度
                let cellHeight=height/6;//单元格高度
                let dataColumn=0;//获取数据需要的列数
                let canvasColumn=Math.round(width / cellHeight);//获取一版画布可以绘制多少列
                let arr;
                if(pearlType==PEARL_TYPE.big_text){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/6);
                }else if(pearlType==PEARL_TYPE.big_hollow||pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    arr=this.$root.setPearlData(this.roomInfo.game,this.pearlArr,Infinity,false);//第一次调用setPearlData是为了去掉和，此时并无法确定要保留多少列
                    pearlType!=PEARL_TYPE.big_hollow&&(arr=this.convertToSmallPearl(arr,pearlType));
                    //循环获取拐弯后真实需要占用的列数
                    var maxPoint = [0, 0, 0, 0, 0, 0];//保存每一行露珠达到的最大x坐标点
                    var lastPoint = 0;
                    for (var i = 0; i <arr.length; i++) {//倒序遍历处理后的数组
                        for (var j = 0, currentRow = 0; j < arr[i].length; j++) {
                            if (currentRow == 6 || (i+1) <= maxPoint[currentRow]) {//已经到达最后一行或者当前要画的x坐标小于或等于当前要画行的最大坐标，即当前要画的位置已有露珠
                                if (!(currentRow == 6 && lastPoint < (i+1) - (arr[i].length - 6))) {//如果非(当前已到达第6行并且向左拐不与当前行最大点重叠)，则向右拐
                                    maxPoint[currentRow - 1] = (i+1) + (j - (currentRow-1));//更新最大坐标点为当前个数-当前所在行+当前列=要画的露珠列
                                }
                            } else {//否则向下画
                                currentRow == 5 && (lastPoint = maxPoint[currentRow] == 0 ? 0 : maxPoint[currentRow]);//如果已是最后一行，则保存最大坐标点，用于左拐判断
                                maxPoint[currentRow] = i+1;//更新最大坐标点
                                currentRow++;//累加当前列露珠到达的行数
                            }
                        }
                    }
                    dataColumn=Math.max.apply(null,maxPoint);
                }else if(pearlType==PEARL_TYPE.big_three){
                    dataColumn=Math.ceil(this.pearlArr.flat(Infinity).length/3);
                }
                if(dataColumn<canvasColumn){//如果数据需要的列数比一版画布的列数少，说明一版够用
                    this.$root.setCanvasSize(elem);//设置画布大小
                    elem.style.left="";
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }else{//一版不够展示
                    //加长画布
                    elem.width=dataColumn*cellHeight*RATIO;
                    elem.height=height*RATIO;
                    elem.style.width=dataColumn*cellHeight+"px";
                    // elem.style.height=height+"px";
                    elem.style.left="";
                    elem.style.left=style.left;
                    obj = this.$root.drawCanvasTable(elem,6,false);
                }
                if(pearlType==PEARL_TYPE.big_text||pearlType==PEARL_TYPE.big_three){
                    this.drawOrderPearl(obj,this.pearlArr,pearlType);
                }else if(pearlType==PEARL_TYPE.big_hollow){
                    this.$root.drawPearl(obj,arr,PEARL_TYPE.big_hollow,GAME_ID.bac);
                }else if(pearlType==PEARL_TYPE.small_hollow||pearlType==PEARL_TYPE.small_solid||pearlType==PEARL_TYPE.bevel){
                    this.$root.drawPearl(obj,
                        this.$root.setPearlData(this.roomInfo.game,arr,Infinity,false),//第二次调用setPearlData是为了保留多少列
                        pearlType,GAME_ID.bac,true);
                }
            }
        },
        /**
         * 移动路单
         */
        movePearlMore(type){
            let elem=document.getElementById("fullPearl");//获取画布元素
            let style=getComputedStyle(elem);//获取画布样式
            let left=Number(style.left.replace('px',''));//获取左边距
            let width=Number(getComputedStyle(elem.parentElement).width.replace('px',''));//获取一版画布的宽度
            let fullWidth=Number(style.width.replace('px',''));//获取整个画布宽度
            type==-1&&(elem.style.left=(Math.abs(left)<=width?0:left+width)+"px");//左边剩下的距离只有不够一版画布的宽度则全部显示，大于一版则只显示一版
            //右边剩下的距离(即画布总宽度-左边剩下的距离-一版画布的宽度)只有不够一版的宽度，则左边距设为总宽度-一版宽度,否则说明剩余超出一版宽度则左边距设为左边距-一版宽度
            type==1&&(elem.style.left=(fullWidth-Math.abs(left)-width<=width?-(fullWidth-width):left-width)+"px");
        },
        // /**
        //  * 自动额度选择
        //  */
        // autoAmount(){
        //     for(let i in this.currAmountList){
        //         if(i.amountList.length==0){
        //             let max=this.limitred.z.split('-')[1];
        //             let arr=[];
        //             if (max<=1000) {
        //                 arr= [[10,20],[50,100],[200]];
        //             }else if ((max>1000&&max<=2000)||(max>2000&&max<=5000)) {
        //                 arr= [[10,50],[100,500],[1000]];
        //             }else if(max>5000&&max<=10000){
        //                 arr= [[10,100],[500,1000],[2000]];
        //             }else if(max>10000&&max<=20000){
        //                 arr= [[10,100],[500,1000],[5000]];
        //             }else if(max>20000&&max<=100000){
        //                 arr= [[10,100],[1000,5000],[10000]];
        //             }else {
        //                 arr= [[10,50],[100,500],[1000]];
        //             }
        //             this.$store.commit({
        //                 type:MUTATION_TYPE.setCurrAmountList,
        //                 currAmountList:{
        //                     id:
        //                     arr
        //                 }
        //             })
        //         }
        //     }
        // },
        /**
         * 设置印记类型
         */
        setMarkType(isReset){
            if(isReset){//重置进度
                if(this.userInfo.mark==0){
                    useLayer({str:"当前进度为0，无需重置！"});
                    return;
                }
                useLayer({type:LAYER_TYPE.confirm,str:"重置进度将会清除所有已获得印记，是否仍然清除？",btn:["清除","算了"],yesFn:()=>{
                    this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,0,this.userInfo.id,this.userInfo.guid);
                }})
            }else{
                console.log(this.currRuleType,this.userInfo.markType)
                if(this.currRuleType>this.userInfo.markType&&this.userInfo.markType!=0){//当前希望升级
                    useLayer({type:LAYER_TYPE.confirm,str:"升级为更高难度后，如需降低难度必须先完成或重置进度，是否仍然升级？",btn:["升级","算了"],yesFn:()=>{
                        this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                    }})
                }else if(this.currRuleType<this.userInfo.markType){//当前希望降级
                    if(this.userInfo.mark==0){//还没有印记随便变更难度
                        this.$emit("ws-send",COMMAND.all_setruletype,RULE_TYPE.mark,this.currRuleType,this.userInfo.id,this.userInfo.guid);
                    }else{//已有印记
                        useLayer({str:"您当前有未完成进度，完成或重置进度后才可降级！"});
                    }
                }
            }
            
        },
        videoReady(videoId){
            this.readyVideoIdArr.push(videoId);
        },
        /**
         * 修改多台列表
         */
        changeBetRoomList(newRoomId,oldRoomId){
            let newBetRoomList=JSON.parse(JSON.stringify(this.betRoomIdList));
            newBetRoomList.splice(this.betRoomIdList.indexOf(oldRoomId),1,newRoomId)
            this.$store.commit({
                type:MUTATION_TYPE.setBetRoomIdList,
                betRoomIdList:newBetRoomList,
            })
        },
        /**
         * 显示鼠标上移台路
         */
        showHoverRoomPearl(room){
            this.currHoverRoom=room;
            this.$nextTick(()=>{
                if(room.id==this.roomInfo.id){
                    this.drawPearl(this.pearlArr,"bigPearl_"+room.id);
                }else{
                    //获取台面路单
                    this.$emit("ws-send",COMMAND.all_getroompearl, room.game,room.id,200,"table", this.userInfo.id, this.userInfo.guid);
                }
            })
        },
        /**
         * 显示更多筹码
         */
        showMoreAmount(id){
            // this.showMoreAmountRoomIdArr= this.showMoreAmountRoomIdArr.filter(v=> this.betRoomIdList.indexOf(v)!=-1);
            this.showMoreAmountRoomIdArr.push({
                id,
                amountArr:[]
            });
        },
        /**
         * 设置多台当前选中筹码
         */
        setRoomAmount(roomid,amount){
            this.betRoomInfoList.find(v=>v.id==roomid)&&(this.betRoomInfoList.find(v=>v.id==roomid).amount=amount);
        },
        /**
         * 设置台面自定筹码
         */
        setRoomAmountList(roomid,amount){
            // if(this.isMultiple){
                let amountObj=this.showMoreAmountRoomIdArr.find(v=>v.id==roomid);
                if(amountObj){
                    let index = amountObj.amountArr.findIndex(v=>v==amount);
                    if(index!=-1){//找到
                        amountObj.amountArr.splice(index,1);
                    }else{//找不到
                        if(amountObj.amountArr.length<5){
                             amountObj.amountArr.push(amount);
                        }else{
                            useLayer({str:"您已经选择了5个，请先取消其中一个"});
                        }
                    }
                }
            // }
        },
        /**
         * 保存自定义筹码
         */
        saveAmount(roomid){
            let amountObj=this.showMoreAmountRoomIdArr.find(v=>v.id==roomid);
            if(amountObj){
                if(amountObj.amountArr.length<5){
                    useLayer({str:"不足5个"});
                }else{
                    this.$store.commit({
                        type:MUTATION_TYPE.setCurrAmountList,
                        currAmountList:{
                            id:roomid,
                            amount:amountObj.amountArr
                        }
                    })
                    this.showMoreAmountRoomIdArr.splice(this.showMoreAmountRoomIdArr.findIndex(v=>v.id==roomid),1);
                }
                            
                
            }
        }
    },
    watch: {
        /**
         * 监听路单数据变化
         */
        pearlArr:{
            handler(newVal){
                this.pearlCount = this.drawPearl(newVal);
                this.drawMorePearl(this.pearlMoreType);
                this.drawPearl(newVal,"bigPearl_"+this.roomInfo.id);
            },
            deep:true//深度监听
        },
        /**
         * 监听视频线路id改变
         */
        currVideoLine(newVal){
            if(newVal!=""){
                //获取台面视频
                newVal&&this.$emit("ws-send",COMMAND.all_getvideo,this.roomInfo.id,newVal,this.userInfo.id,this.userInfo.guid);
            }else{
                this.videoList=null;
            }
        },
        /**
         * 监听将要提交的额度变化
         */
        submiting:{
            handler(){
                if(this.getAmountCount("submiting")<=0){
                    this.canClear=false;
                    this.canConfirm=false;
                }else{
                    this.canClear=true;
                    this.canConfirm=true;
                }
            },
            deep:true
        },
        /**
         * 监听已提交过的额度变化
         */
        submited:{
            handler(){
                if(this.getAmountCount("submited")<=0){
                    this.canCancel=false;
                }else{
                    this.canCancel=true;
                }
            },
            deep:true
        },
        "roomInfo.countdown"(newVal){
            if(this.getAmountCount("lastSubmit")>0&&newVal>0){
                this.canAgain=true;
            }
        },
        /**
         * 监听路单模式改变
         */
        pearlModel(){
            this.$nextTick(()=>{
                this.drawPearl(this.pearlArr);
                this.drawMorePearl(this.pearlMoreType);
            })
        },
        /**
         * 监听guid改变（断线重连）
         */
        "userInfo.guid"(newVal,oldVal){
            if(newVal!=oldVal&&newVal!=""){
                this.init();
            }
        },
        readyVideoIdArr(val){
            console.log(val+"------------------------------------");
        },
        betRoomIdList:{
            handler(newVal,oldVal){
                let diffArr=[];//不同于上一次的台数组
                diffArr=newVal.filter(v=>oldVal.indexOf(v)==-1);//找到旧数组中没有的元素
                
                for (let i = 0; i < diffArr.length; i++) {
                    let room=this.roomList.find(v=>v.id==diffArr[i]);
                    if(room){
                        this.$emit("ws-send",COMMAND.all_getvideo,room.id,this.$root.getDefaultLineId(room.rid),this.userInfo.id,this.userInfo.guid);
                        this.$emit("ws-send",COMMAND.all_getroompearl, room.game,diffArr[i],200,"table", this.userInfo.id, this.userInfo.guid);
                        //获取各位置已提交额度
                        this.$emit("ws-send",COMMAND.bac_getbetdetail,room.id,room.boot,room.innings,this.userInfo.id,this.userInfo.guid);
                        let info = this.betRoomInfoList.find(v=>v.id==room.id);
                        if(!info){
                            this.betRoomInfoList.push({
                                id:room.id,
                                amount:0,
                                submiting:{z:0,x:0,h:0,zd:0,xd:0},
                                submited:{z:0,x:0,h:0,zd:0,xd:0},
                                currRebate:REBATE_TYPE.rebate,
                                submitedCount:0,
                            });
                        }
                    }
                }
            },
            deep:true//深度监听
        },
        betPearlList:{
            handler(newVal){
                for (let i = 0; i < newVal.length; i++) {
                    this.pearlCountList[newVal[i].id]=this.drawPearl(newVal[i].pearl,'textBigPearl'+newVal[i].id);
                }
            },
            deep:true//深度监听
        }
    },
};
</script>